//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {CustomerStore} from './customer.store';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import moment from 'moment';
import 'moment-duration-format';

export const API_BASE_URL_PUBLIC = new InjectionToken<string>('API_BASE_URL_PUBLIC');

export class PublicClientBase {

  private readonly store: CustomerStore;

  protected constructor(store: CustomerStore) {
    this.store = store;
  }

  protected async transformOptions(options: any): Promise<any> {
    const token = await this.store.accessToken();
    options.headers = options.headers.append('Authorization', `Bearer ${token}`);
    return options;
  }
}

@Injectable()
export class PetsHubPublicClient extends PublicClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(CustomerStore) configuration: CustomerStore, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_PUBLIC) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44310";
    }

    /**
     * Current user
     * @return Returns actual data of current user
     */
    profile(hubUrl: string): Observable<Profile> {
        let url_ = this.baseUrl + "/{hubUrl}/profile";
        if (hubUrl === undefined || hubUrl === null)
            throw new Error("The parameter 'hubUrl' must be defined.");
        url_ = url_.replace("{hubUrl}", encodeURIComponent("" + hubUrl));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Profile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Profile>;
        }));
    }

    protected processProfile(response: HttpResponseBase): Observable<Profile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Profile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Pets of the current user
     */
    shares(hubUrl: string): Observable<Pet[]> {
        let url_ = this.baseUrl + "/{hubUrl}/shares";
        if (hubUrl === undefined || hubUrl === null)
            throw new Error("The parameter 'hubUrl' must be defined.");
        url_ = url_.replace("{hubUrl}", encodeURIComponent("" + hubUrl));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processShares(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShares(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Pet[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Pet[]>;
        }));
    }

    protected processShares(response: HttpResponseBase): Observable<Pet[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Pet.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Collars of the current user
     */
    collars(hubUrl: string): Observable<Collar[]> {
        let url_ = this.baseUrl + "/{hubUrl}/collars";
        if (hubUrl === undefined || hubUrl === null)
            throw new Error("The parameter 'hubUrl' must be defined.");
        url_ = url_.replace("{hubUrl}", encodeURIComponent("" + hubUrl));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCollars(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCollars(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Collar[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Collar[]>;
        }));
    }

    protected processCollars(response: HttpResponseBase): Observable<Collar[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Collar.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Flashlights of the current user
     */
    flashlights(hubUrl: string): Observable<Flashlight[]> {
        let url_ = this.baseUrl + "/{hubUrl}/flashlights";
        if (hubUrl === undefined || hubUrl === null)
            throw new Error("The parameter 'hubUrl' must be defined.");
        url_ = url_.replace("{hubUrl}", encodeURIComponent("" + hubUrl));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFlashlights(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFlashlights(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Flashlight[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Flashlight[]>;
        }));
    }

    protected processFlashlights(response: HttpResponseBase): Observable<Flashlight[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Flashlight.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Safe zones of the current user
     */
    safeZones(hubUrl: string): Observable<SafeZone[]> {
        let url_ = this.baseUrl + "/{hubUrl}/safe-zones";
        if (hubUrl === undefined || hubUrl === null)
            throw new Error("The parameter 'hubUrl' must be defined.");
        url_ = url_.replace("{hubUrl}", encodeURIComponent("" + hubUrl));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSafeZones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSafeZones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SafeZone[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SafeZone[]>;
        }));
    }

    protected processSafeZones(response: HttpResponseBase): Observable<SafeZone[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SafeZone.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Pets footprints
     * @param petId (optional) Pet identifier.
     * @param length (optional) Number of points on the map.
     */
    trail(petId: string | undefined, length: number | undefined, hubUrl: string): Observable<TrailPoint[]> {
        let url_ = this.baseUrl + "/{hubUrl}/trail?";
        if (hubUrl === undefined || hubUrl === null)
            throw new Error("The parameter 'hubUrl' must be defined.");
        url_ = url_.replace("{hubUrl}", encodeURIComponent("" + hubUrl));
        if (petId === null)
            throw new Error("The parameter 'petId' cannot be null.");
        else if (petId !== undefined)
            url_ += "petId=" + encodeURIComponent("" + petId) + "&";
        if (length === null)
            throw new Error("The parameter 'length' cannot be null.");
        else if (length !== undefined)
            url_ += "length=" + encodeURIComponent("" + length) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTrail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrailPoint[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrailPoint[]>;
        }));
    }

    protected processTrail(response: HttpResponseBase): Observable<TrailPoint[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrailPoint.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Pets walkers
     * @param petId (optional) Pet identifier.
     * @return Returns users who are near the pet.
     */
    walkers(petId: string | undefined, hubUrl: string): Observable<ProfilePartial[]> {
        let url_ = this.baseUrl + "/{hubUrl}/walkers?";
        if (hubUrl === undefined || hubUrl === null)
            throw new Error("The parameter 'hubUrl' must be defined.");
        url_ = url_.replace("{hubUrl}", encodeURIComponent("" + hubUrl));
        if (petId === null)
            throw new Error("The parameter 'petId' cannot be null.");
        else if (petId !== undefined)
            url_ += "petId=" + encodeURIComponent("" + petId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processWalkers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWalkers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfilePartial[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfilePartial[]>;
        }));
    }

    protected processWalkers(response: HttpResponseBase): Observable<ProfilePartial[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProfilePartial.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GeoPublicClient extends PublicClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(CustomerStore) configuration: CustomerStore, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_PUBLIC) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44310";
    }

    /**
     * Получение адреса по гео координатам.
     * @param lat (optional) Широта.
     * @param lon (optional) Долгота.
     * @return Возвращает адрес.
     */
    getAddress(lat: number | undefined, lon: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/mobile/geo/address?";
        if (lat === null)
            throw new Error("The parameter 'lat' cannot be null.");
        else if (lat !== undefined)
            url_ += "lat=" + encodeURIComponent("" + lat) + "&";
        if (lon === null)
            throw new Error("The parameter 'lon' cannot be null.");
        else if (lon !== undefined)
            url_ += "lon=" + encodeURIComponent("" + lon) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAddress(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Поиск адреса с автоподстановкой.
     * @param search (optional) Строка поиска.
     * @param lat (optional) Широта.
     * @param lon (optional) Долгота.
     * @return Возвращает список подходящих адресов.
     */
    getPlaceAutocomplete(search: string | null | undefined, lat: number | null | undefined, lon: number | null | undefined): Observable<GeoPlaceModel[]> {
        let url_ = this.baseUrl + "/api/mobile/geo/place-autocomplete?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (lat !== undefined && lat !== null)
            url_ += "lat=" + encodeURIComponent("" + lat) + "&";
        if (lon !== undefined && lon !== null)
            url_ += "lon=" + encodeURIComponent("" + lon) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPlaceAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlaceAutocomplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeoPlaceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeoPlaceModel[]>;
        }));
    }

    protected processGetPlaceAutocomplete(response: HttpResponseBase): Observable<GeoPlaceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GeoPlaceModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Получение детальной информации о месте.
     * @param id (optional) Строка поиска.
     * @return Возвращает детальную информацию о месте.
     */
    getPlaceDetails(id: string | null | undefined): Observable<GeoPointModel> {
        let url_ = this.baseUrl + "/api/mobile/geo/place-details?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPlaceDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlaceDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeoPointModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeoPointModel>;
        }));
    }

    protected processGetPlaceDetails(response: HttpResponseBase): Observable<GeoPointModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GeoPointModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TimelinePublicClient extends PublicClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(CustomerStore) configuration: CustomerStore, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_PUBLIC) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44310";
    }

    /**
     * Getting a tree of walks/rest of the pet
     * @param petId Pet identifier
     */
    getTimelineTree(petId: string): Observable<TimelineTree> {
        let url_ = this.baseUrl + "/api/mobile/pets/{pet_id}/timeline-tree";
        if (petId === undefined || petId === null)
            throw new Error("The parameter 'petId' must be defined.");
        url_ = url_.replace("{pet_id}", encodeURIComponent("" + petId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTimelineTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimelineTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimelineTree>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimelineTree>;
        }));
    }

    protected processGetTimelineTree(response: HttpResponseBase): Observable<TimelineTree> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimelineTree.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("No access to view walks", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Pet not found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Getting a plain list of walks/rest of the pet
     * @param petId Pet identifier
     * @param year Year of the received data
     * @param month Month of the received data
     */
    getTimelinePlain(petId: string, year: number, month: number): Observable<Timeline[]> {
        let url_ = this.baseUrl + "/api/mobile/pets/{pet_id}/timeline/{year}-{month}/plain";
        if (petId === undefined || petId === null)
            throw new Error("The parameter 'petId' must be defined.");
        url_ = url_.replace("{pet_id}", encodeURIComponent("" + petId));
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined.");
        url_ = url_.replace("{month}", encodeURIComponent("" + month));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTimelinePlain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimelinePlain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Timeline[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Timeline[]>;
        }));
    }

    protected processGetTimelinePlain(response: HttpResponseBase): Observable<Timeline[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Timeline.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("No access to view walks", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Pet not found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Getting a grouped list of walks/rest of the pet
     * @param petId Pet identifier
     * @param year Year of the received data
     * @param month Month of the received data
     */
    getTimelineGroup(petId: string, year: number, month: number): Observable<{ [key: string]: Timeline[]; }> {
        let url_ = this.baseUrl + "/api/mobile/pets/{pet_id}/timeline/{year}-{month}";
        if (petId === undefined || petId === null)
            throw new Error("The parameter 'petId' must be defined.");
        url_ = url_.replace("{pet_id}", encodeURIComponent("" + petId));
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined.");
        url_ = url_.replace("{month}", encodeURIComponent("" + month));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTimelineGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimelineGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: Timeline[]; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: Timeline[]; }>;
        }));
    }

    protected processGetTimelineGroup(response: HttpResponseBase): Observable<{ [key: string]: Timeline[]; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? resultData200[key].map((i: any) => Timeline.fromJS(i)) : [];
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("No access to view walks", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Pet not found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Getting a walk
     * @param petId Pet identifier
     * @param walkId Walk identifier
     */
    getWalk(petId: string, walkId: string): Observable<Walk> {
        let url_ = this.baseUrl + "/api/mobile/pets/{pet_id}/walks/{walk_id}";
        if (petId === undefined || petId === null)
            throw new Error("The parameter 'petId' must be defined.");
        url_ = url_.replace("{pet_id}", encodeURIComponent("" + petId));
        if (walkId === undefined || walkId === null)
            throw new Error("The parameter 'walkId' must be defined.");
        url_ = url_.replace("{walk_id}", encodeURIComponent("" + walkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWalk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWalk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Walk>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Walk>;
        }));
    }

    protected processGetWalk(response: HttpResponseBase): Observable<Walk> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Walk.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("No access to view walk", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Walk not found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update comment of walk
     * @param petId Pet identifier
     * @param walkId Walk identifier
     * @param comment (optional)
     */
    setWalkNote(petId: string, walkId: string, comment: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/mobile/pets/{pet_id}/walks/{walk_id}";
        if (petId === undefined || petId === null)
            throw new Error("The parameter 'petId' must be defined.");
        url_ = url_.replace("{pet_id}", encodeURIComponent("" + petId));
        if (walkId === undefined || walkId === null)
            throw new Error("The parameter 'walkId' must be defined.");
        url_ = url_.replace("{walk_id}", encodeURIComponent("" + walkId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (comment !== null && comment !== undefined)
            content_.append("comment", comment.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetWalkNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetWalkNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSetWalkNote(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Walk not found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deleting a walk
     * @param petId Pet identifier
     * @param walkId Walk identifier
     */
    deleteWalk(petId: string, walkId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/pets/{pet_id}/walks/{walk_id}";
        if (petId === undefined || petId === null)
            throw new Error("The parameter 'petId' must be defined.");
        url_ = url_.replace("{pet_id}", encodeURIComponent("" + petId));
        if (walkId === undefined || walkId === null)
            throw new Error("The parameter 'walkId' must be defined.");
        url_ = url_.replace("{walk_id}", encodeURIComponent("" + walkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteWalk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWalk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWalk(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("The user is not the owner of the pet whose walk is being deleted", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Walk not found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Getting a rest history
     * @param petId Pet identifier
     * @param restId Rest history identifier
     */
    getRest(petId: string, restId: string): Observable<Rest> {
        let url_ = this.baseUrl + "/api/mobile/pets/{pet_id}/rests/{rest_id}";
        if (petId === undefined || petId === null)
            throw new Error("The parameter 'petId' must be defined.");
        url_ = url_.replace("{pet_id}", encodeURIComponent("" + petId));
        if (restId === undefined || restId === null)
            throw new Error("The parameter 'restId' must be defined.");
        url_ = url_.replace("{rest_id}", encodeURIComponent("" + restId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Rest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Rest>;
        }));
    }

    protected processGetRest(response: HttpResponseBase): Observable<Rest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Rest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("No access to view rest history", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Rest history not found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deleting a rest history
     * @param petId Pet identifier
     * @param restId Rest history identifier
     */
    deleteRest(petId: string, restId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/pets/{pet_id}/rests/{rest_id}";
        if (petId === undefined || petId === null)
            throw new Error("The parameter 'petId' must be defined.");
        url_ = url_.replace("{pet_id}", encodeURIComponent("" + petId));
        if (restId === undefined || restId === null)
            throw new Error("The parameter 'restId' must be defined.");
        url_ = url_.replace("{rest_id}", encodeURIComponent("" + restId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteRest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("The user is not the owner of the pet whose rest history is being deleted", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Rest history not found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InvitePublicClient extends PublicClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(CustomerStore) configuration: CustomerStore, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_PUBLIC) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44310";
    }

    /**
     * Получение отправленных приглашений
     * @return Возвращает отправленные приглашения
     * @deprecated
     */
    getInvites(): Observable<Invite2[]> {
        let url_ = this.baseUrl + "/api/mobile/invite";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetInvites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Invite2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Invite2[]>;
        }));
    }

    protected processGetInvites(response: HttpResponseBase): Observable<Invite2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Invite2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Отправляет приглашение "Поделиться питомцем"
     * @param petId (optional)
     * @param email (optional)
     * @param level (optional)
     * @return Успешное завершение
     */
    createPetInvite(petId: string | null | undefined, email: string | null | undefined, level: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (petId !== null && petId !== undefined)
            content_.append("PetId", petId.toString());
        if (email !== null && email !== undefined)
            content_.append("Email", email.toString());
        if (level !== null && level !== undefined)
            content_.append("Level", level.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePetInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePetInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreatePetInvite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("\n            \u041f\u0440\u0438\u0433\u043b\u0430\u0448\u0435\u043d\u0438\u0435 \u0443\u0436\u0435 \u0431\u044b\u043b\u043e \u043e\u0442\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u043e\n            \u0438\u043b\u0438 \u043f\u0438\u0442\u043e\u043c\u0435\u0446 \u0443\u0436\u0435 \u043f\u043e\u0448\u0430\u0440\u0435\u043d \u0446\u0435\u043b\u0435\u0432\u043e\u043c\u0443 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044e\n            \u0438\u043b\u0438 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044c \u043e\u0442\u0440\u0430\u0432\u0438\u043b \u043f\u0440\u0438\u0433\u043b\u0430\u0448\u0435\u043d\u0438\u0435 \u0441\u0430\u043c\u043e\u043c\u0443 \u0441\u0435\u0431\u0435", status, _responseText, _headers, result409);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("\u041f\u0438\u0442\u043e\u043c\u0435\u0446 \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d \u0438\u043b\u0438 \u0443\u0434\u0430\u043b\u0435\u043d.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Получение журнала отправленных приглашений
     * @return Возвращает журнал отправленных приглашений
     */
    journal(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/mobile/invite/journal";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processJournal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJournal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processJournal(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Получение отправленного приглашения
     * @param inviteId Идентификатор приглашения
     * @return Возвращает приглашение
     * @deprecated
     */
    getInvite(inviteId: string): Observable<Invite2> {
        let url_ = this.baseUrl + "/api/mobile/invite/{invite_id}";
        if (inviteId === undefined || inviteId === null)
            throw new Error("The parameter 'inviteId' must be defined.");
        url_ = url_.replace("{invite_id}", encodeURIComponent("" + inviteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Invite2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Invite2>;
        }));
    }

    protected processGetInvite(response: HttpResponseBase): Observable<Invite2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Invite2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Отзывает отправленное ранее приглашение, если оно еще не принято
     * @return Успешное завершение
     */
    deleteInvite(inviteId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/invite/{invite_id}";
        if (inviteId === undefined || inviteId === null)
            throw new Error("The parameter 'inviteId' must be defined.");
        url_ = url_.replace("{invite_id}", encodeURIComponent("" + inviteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteInvite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("\u041f\u0440\u0438\u0433\u043b\u0430\u0448\u0435\u043d\u0438\u0435 \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u043e", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Принимает или отклоняет приглашение
     * @param inviteId Идентификатор приглашения
     * @param status (optional)
     * @return Успешное выполнение
     */
    updateInvite(inviteId: string, status: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/invite/{invite_id}";
        if (inviteId === undefined || inviteId === null)
            throw new Error("The parameter 'inviteId' must be defined.");
        url_ = url_.replace("{invite_id}", encodeURIComponent("" + inviteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (status === null || status === undefined)
            throw new Error("The parameter 'status' cannot be null.");
        else
            content_.append("Status", status.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateInvite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInvite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateInvite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("\u041f\u0440\u0438\u0433\u043b\u0430\u0448\u0435\u043d\u0438\u0435 \u0443\u0436\u0435 \u0431\u044b\u043b\u043e \u043e\u0442\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u043e \u0438\u043b\u0438 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044c \u0443\u0436\u0435 \u043f\u0440\u0438\u043d\u044f\u043b \u043f\u0440\u0438\u0433\u043b\u0430\u0448\u0435\u043d\u0438\u0435", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("\u041f\u0438\u0442\u043e\u043c\u0435\u0446 \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SafeZonesPublicClient extends PublicClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(CustomerStore) configuration: CustomerStore, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_PUBLIC) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44310";
    }

    /**
     * Add safe zone
     * @param name (optional)
     * @param polygon (optional)
     * @param access_points (optional)
     * @param beacons (optional)
     * @param include_pets (optional)
     */
    addSafeZone(name: string | null | undefined, polygon: string | null | undefined, access_points: AddAccessPoint[] | null | undefined, beacons: AddBeacon[] | null | undefined, include_pets: boolean | undefined): Observable<IdResult> {
        let url_ = this.baseUrl + "/safe-zones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("name", name.toString());
        if (polygon !== null && polygon !== undefined)
            content_.append("polygon", polygon.toString());
        if (access_points !== null && access_points !== undefined)
            access_points.forEach(item_ => content_.append("access_points", item_.toString()));
        if (beacons !== null && beacons !== undefined)
            beacons.forEach(item_ => content_.append("beacons", item_.toString()));
        if (include_pets === null || include_pets === undefined)
            throw new Error("The parameter 'include_pets' cannot be null.");
        else
            content_.append("include_pets", include_pets.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddSafeZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSafeZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IdResult>;
        }));
    }

    protected processAddSafeZone(response: HttpResponseBase): Observable<IdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Safe zone limitations reached", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update safe zone
     * @param name (optional)
     * @param polygon (optional)
     */
    editSafeZone(id: string, name: string | null | undefined, polygon: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/safe-zones/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("name", name.toString());
        if (polygon !== null && polygon !== undefined)
            content_.append("polygon", polygon.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processEditSafeZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditSafeZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditSafeZone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Specified safe zone doesn\'t belong to the current user", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Safe zone not found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete safe zone
     */
    deleteSafeZone(id: string): Observable<void> {
        let url_ = this.baseUrl + "/safe-zones/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteSafeZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSafeZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSafeZone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Specified safe zone doesn\'t belong to the current user", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Safe zone not found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add Wi-FI ap
     * @param ssid (optional)
     * @param password (optional)
     * @param connection_status (optional)
     */
    addAccessPoint(safeZoneId: string, ssid: string | null | undefined, password: string | null | undefined, connection_status: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/safe-zones/{safe_zone_id}/ap";
        if (safeZoneId === undefined || safeZoneId === null)
            throw new Error("The parameter 'safeZoneId' must be defined.");
        url_ = url_.replace("{safe_zone_id}", encodeURIComponent("" + safeZoneId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (ssid !== null && ssid !== undefined)
            content_.append("ssid", ssid.toString());
        if (password !== null && password !== undefined)
            content_.append("password", password.toString());
        if (connection_status !== null && connection_status !== undefined)
            content_.append("connection_status", connection_status.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddAccessPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAccessPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddAccessPoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Specified safe zone doesn\'t belong to the current user", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Safe zone not found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update Wi-FI ap
     * @param ssid (optional)
     * @param password (optional)
     */
    editAccessPoint(safeZoneId: string, id: string, ssid: string | null | undefined, password: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/safe-zones/{safe_zone_id}/ap/{ssid}";
        if (safeZoneId === undefined || safeZoneId === null)
            throw new Error("The parameter 'safeZoneId' must be defined.");
        url_ = url_.replace("{safe_zone_id}", encodeURIComponent("" + safeZoneId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{ssid}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (ssid !== null && ssid !== undefined)
            content_.append("ssid", ssid.toString());
        if (password !== null && password !== undefined)
            content_.append("password", password.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processEditAccessPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditAccessPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditAccessPoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Specified safe zone doesn\'t belong to the current user", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Safe zone not found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete Wi-Fi ap
     */
    deleteAccessPoint(safeZoneId: string, id: string): Observable<void> {
        let url_ = this.baseUrl + "/safe-zones/{safe_zone_id}/ap/{ssid}";
        if (safeZoneId === undefined || safeZoneId === null)
            throw new Error("The parameter 'safeZoneId' must be defined.");
        url_ = url_.replace("{safe_zone_id}", encodeURIComponent("" + safeZoneId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{ssid}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteAccessPoint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAccessPoint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAccessPoint(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Specified safe zone doesn\'t belong to the current user", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Safe zone not found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add BLE beacon
     * @param name (optional)
     * @param mac_address (optional)
     * @param restricted (optional)
     * @param voltage (optional)
     */
    addBeacon(safeZoneId: string, name: string | null | undefined, mac_address: string | null | undefined, restricted: boolean | undefined, voltage: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/safe-zones/{safe_zone_id}/beacon";
        if (safeZoneId === undefined || safeZoneId === null)
            throw new Error("The parameter 'safeZoneId' must be defined.");
        url_ = url_.replace("{safe_zone_id}", encodeURIComponent("" + safeZoneId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("name", name.toString());
        if (mac_address !== null && mac_address !== undefined)
            content_.append("mac_address", mac_address.toString());
        if (restricted === null || restricted === undefined)
            throw new Error("The parameter 'restricted' cannot be null.");
        else
            content_.append("restricted", restricted.toString());
        if (voltage !== null && voltage !== undefined)
            content_.append("voltage", voltage.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddBeacon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddBeacon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddBeacon(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Specified safe zone doesn\'t belong to the current user", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Safe zone not found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update BLE beacon
     * @param name (optional)
     * @param restricted (optional)
     */
    editBeacon(safeZoneId: string, macAddress: string, name: string | null | undefined, restricted: boolean | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/safe-zones/{safe_zone_id}/beacon/{mac_address}";
        if (safeZoneId === undefined || safeZoneId === null)
            throw new Error("The parameter 'safeZoneId' must be defined.");
        url_ = url_.replace("{safe_zone_id}", encodeURIComponent("" + safeZoneId));
        if (macAddress === undefined || macAddress === null)
            throw new Error("The parameter 'macAddress' must be defined.");
        url_ = url_.replace("{mac_address}", encodeURIComponent("" + macAddress));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("name", name.toString());
        if (restricted !== null && restricted !== undefined)
            content_.append("restricted", restricted.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processEditBeacon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditBeacon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditBeacon(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Specified safe zone doesn\'t belong to the current user", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Safe zone not found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete BLE beacon
     */
    deleteBeacon(safeZoneId: string, macAddress: string): Observable<void> {
        let url_ = this.baseUrl + "/safe-zones/{safe_zone_id}/beacon/{mac_address}";
        if (safeZoneId === undefined || safeZoneId === null)
            throw new Error("The parameter 'safeZoneId' must be defined.");
        url_ = url_.replace("{safe_zone_id}", encodeURIComponent("" + safeZoneId));
        if (macAddress === undefined || macAddress === null)
            throw new Error("The parameter 'macAddress' must be defined.");
        url_ = url_.replace("{mac_address}", encodeURIComponent("" + macAddress));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteBeacon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBeacon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBeacon(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Specified safe zone doesn\'t belong to the current user", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Safe zone not found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BreedPublicClient extends PublicClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(CustomerStore) configuration: CustomerStore, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_PUBLIC) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44310";
    }

    /**
     * Получение пород.
     * @return Возвращает породы.
     */
    getBreeds(): Observable<BreedLegacy[]> {
        let url_ = this.baseUrl + "/api/mobile/breed";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBreeds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBreeds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BreedLegacy[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BreedLegacy[]>;
        }));
    }

    protected processGetBreeds(response: HttpResponseBase): Observable<BreedLegacy[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BreedLegacy.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PetPublicClient extends PublicClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(CustomerStore) configuration: CustomerStore, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_PUBLIC) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44310";
    }

    /**
     * Получение питомцев для виджета
     * @return Возвращает питомцев текущего пользователя.
     */
    getWidgetPets(): Observable<WidgetPet[]> {
        let url_ = this.baseUrl + "/api/mobile/pet/widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWidgetPets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWidgetPets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WidgetPet[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WidgetPet[]>;
        }));
    }

    protected processGetWidgetPets(response: HttpResponseBase): Observable<WidgetPet[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WidgetPet.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Добавление питомца.
     * @param addSafeZones (optional)
     * @param safe_zones (optional)
     * @param alias (optional)
     * @param fullName (optional)
     * @param sex (optional)
     * @param breed_id (optional)
     * @param birth_date (optional)
     * @param note (optional)
     * @param weight (optional)
     * @param height (optional)
     * @param goal (optional)
     * @param avatar_file (optional)
     * @param stepDistanceRatio (optional)
     * @param runDistanceRatio (optional)
     * @param gallopDistanceRatio (optional)
     */
    createPet(addSafeZones: boolean | null | undefined, safe_zones: string[] | null | undefined, alias: string | null | undefined, fullName: string | null | undefined, sex: string | null | undefined, breed_id: string | null | undefined, birth_date: string | null | undefined, note: string | null | undefined, weight: number | null | undefined, height: number | null | undefined, goal: number | null | undefined, avatar_file: FileParameter | null | undefined, stepDistanceRatio: number | null | undefined, runDistanceRatio: number | null | undefined, gallopDistanceRatio: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/pet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (addSafeZones !== null && addSafeZones !== undefined)
            content_.append("AddSafeZones", addSafeZones.toString());
        if (safe_zones !== null && safe_zones !== undefined)
            safe_zones.forEach(item_ => content_.append("safe_zones", item_.toString()));
        if (alias !== null && alias !== undefined)
            content_.append("Alias", alias.toString());
        if (fullName !== null && fullName !== undefined)
            content_.append("FullName", fullName.toString());
        if (sex !== null && sex !== undefined)
            content_.append("Sex", sex.toString());
        if (breed_id !== null && breed_id !== undefined)
            content_.append("breed_id", breed_id.toString());
        if (birth_date !== null && birth_date !== undefined)
            content_.append("birth_date", birth_date.toString());
        if (note !== null && note !== undefined)
            content_.append("Note", note.toString());
        if (weight !== null && weight !== undefined)
            content_.append("Weight", weight.toString());
        if (height !== null && height !== undefined)
            content_.append("Height", height.toString());
        if (goal !== null && goal !== undefined)
            content_.append("Goal", goal.toString());
        if (avatar_file !== null && avatar_file !== undefined)
            content_.append("avatar_file", avatar_file.data, avatar_file.fileName ? avatar_file.fileName : "avatar_file");
        if (stepDistanceRatio !== null && stepDistanceRatio !== undefined)
            content_.append("StepDistanceRatio", stepDistanceRatio.toString());
        if (runDistanceRatio !== null && runDistanceRatio !== undefined)
            content_.append("RunDistanceRatio", runDistanceRatio.toString());
        if (gallopDistanceRatio !== null && gallopDistanceRatio !== undefined)
            content_.append("GallopDistanceRatio", gallopDistanceRatio.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreatePet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("\u041e\u0448\u0438\u0431\u043a\u0438 \u043f\u0440\u0438 \u0437\u0430\u043f\u043e\u043b\u043d\u0435\u043d\u0438\u0438 \u0444\u043e\u0440\u043c\u044b.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Обновление питомца.
     * @param petId Идентификатор питомца.
     * @param alias (optional)
     * @param fullName (optional)
     * @param sex (optional)
     * @param breed_id (optional)
     * @param birth_date (optional)
     * @param note (optional)
     * @param weight (optional)
     * @param height (optional)
     * @param goal (optional)
     * @param avatar_file (optional)
     * @param stepDistanceRatio (optional)
     * @param runDistanceRatio (optional)
     * @param gallopDistanceRatio (optional)
     */
    editPet(petId: string, alias: string | null | undefined, fullName: string | null | undefined, sex: string | null | undefined, breed_id: string | null | undefined, birth_date: string | null | undefined, note: string | null | undefined, weight: number | null | undefined, height: number | null | undefined, goal: number | null | undefined, avatar_file: FileParameter | null | undefined, stepDistanceRatio: number | null | undefined, runDistanceRatio: number | null | undefined, gallopDistanceRatio: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/pet/{pet_id}";
        if (petId === undefined || petId === null)
            throw new Error("The parameter 'petId' must be defined.");
        url_ = url_.replace("{pet_id}", encodeURIComponent("" + petId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (alias !== null && alias !== undefined)
            content_.append("Alias", alias.toString());
        if (fullName !== null && fullName !== undefined)
            content_.append("FullName", fullName.toString());
        if (sex !== null && sex !== undefined)
            content_.append("Sex", sex.toString());
        if (breed_id !== null && breed_id !== undefined)
            content_.append("breed_id", breed_id.toString());
        if (birth_date !== null && birth_date !== undefined)
            content_.append("birth_date", birth_date.toString());
        if (note !== null && note !== undefined)
            content_.append("Note", note.toString());
        if (weight !== null && weight !== undefined)
            content_.append("Weight", weight.toString());
        if (height !== null && height !== undefined)
            content_.append("Height", height.toString());
        if (goal !== null && goal !== undefined)
            content_.append("Goal", goal.toString());
        if (avatar_file !== null && avatar_file !== undefined)
            content_.append("avatar_file", avatar_file.data, avatar_file.fileName ? avatar_file.fileName : "avatar_file");
        if (stepDistanceRatio !== null && stepDistanceRatio !== undefined)
            content_.append("StepDistanceRatio", stepDistanceRatio.toString());
        if (runDistanceRatio !== null && runDistanceRatio !== undefined)
            content_.append("RunDistanceRatio", runDistanceRatio.toString());
        if (gallopDistanceRatio !== null && gallopDistanceRatio !== undefined)
            content_.append("GallopDistanceRatio", gallopDistanceRatio.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processEditPet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditPet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditPet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("\u0417\u0430\u043f\u0440\u0435\u0449\u0435\u043d\u043e \u0440\u0435\u0434\u0430\u043a\u0442\u0438\u0440\u043e\u0432\u0430\u0442\u044c \u0447\u0443\u0436\u043e\u0433\u043e \u043f\u0438\u0442\u043e\u043c\u0446\u0430.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("\u041f\u0438\u0442\u043e\u043c\u0435\u0446 \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d.", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("\u041e\u0448\u0438\u0431\u043a\u0438 \u043f\u0440\u0438 \u0437\u0430\u043f\u043e\u043b\u043d\u0435\u043d\u0438\u0438 \u0444\u043e\u0440\u043c\u044b.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Удалить своего питомца или убрать чужого питомца из своего профиля
     * @param petId Идентификатор питомца
     * @return Успешное выполнение
     */
    deletePet(petId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/pet/{pet_id}";
        if (petId === undefined || petId === null)
            throw new Error("The parameter 'petId' must be defined.");
        url_ = url_.replace("{pet_id}", encodeURIComponent("" + petId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the pet's avatar
     */
    deleteAvatar(petId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/pet/{pet_id}/avatar";
        if (petId === undefined || petId === null)
            throw new Error("The parameter 'petId' must be defined.");
        url_ = url_.replace("{pet_id}", encodeURIComponent("" + petId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteAvatar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAvatar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAvatar(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Получение статистики питомца.
     * @param petId Идентификатор питомца.
     * @param scale Детализация (1 - день, 2 - неделя, 3 - месяц, 4 - год).
     * @param date (optional) Дата.
     * @return Возвращает дерево статистики питомца.
     */
    getPetStatTree(petId: string, scale: Scale, date: moment.Moment | undefined): Observable<PetStatTreeDto> {
        let url_ = this.baseUrl + "/api/mobile/pet/{pet_id}/stat-tree/{scale}?";
        if (petId === undefined || petId === null)
            throw new Error("The parameter 'petId' must be defined.");
        url_ = url_.replace("{pet_id}", encodeURIComponent("" + petId));
        if (scale === undefined || scale === null)
            throw new Error("The parameter 'scale' must be defined.");
        url_ = url_.replace("{scale}", encodeURIComponent("" + scale));
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPetStatTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPetStatTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PetStatTreeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PetStatTreeDto>;
        }));
    }

    protected processGetPetStatTree(response: HttpResponseBase): Observable<PetStatTreeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PetStatTreeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043a\u0443 \u043c\u043e\u0433\u0443\u0442 \u043f\u0440\u043e\u0441\u043c\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044c \u0442\u043e\u043b\u044c\u043a\u043e \u0432\u043b\u0430\u0434\u0435\u043b\u0435\u0446 \u0438 \u043f\u043e\u0448\u0430\u0440\u0435\u043d\u043d\u044b\u0435 \u0447\u043b\u0435\u043d\u044b \u0441\u0435\u043c\u044c\u0438.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("\u041f\u0438\u0442\u043e\u043c\u0435\u0446 \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Получение статистики отдыха питомца.
     * @param petId Идентификатор питомца.
     * @param scale Детализация (1 - день, 2 - неделя, 3 - месяц, 4 - год).
     * @param date (optional) Дата.
     * @return Возвращает дерево статистики питомца.
     */
    getRestTree(petId: string, scale: Scale, date: moment.Moment | undefined): Observable<PetRestTreeDto> {
        let url_ = this.baseUrl + "/api/mobile/pet/{pet_id}/stat-tree/{scale}/rest?";
        if (petId === undefined || petId === null)
            throw new Error("The parameter 'petId' must be defined.");
        url_ = url_.replace("{pet_id}", encodeURIComponent("" + petId));
        if (scale === undefined || scale === null)
            throw new Error("The parameter 'scale' must be defined.");
        url_ = url_.replace("{scale}", encodeURIComponent("" + scale));
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRestTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRestTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PetRestTreeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PetRestTreeDto>;
        }));
    }

    protected processGetRestTree(response: HttpResponseBase): Observable<PetRestTreeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PetRestTreeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043a\u0443 \u043c\u043e\u0433\u0443\u0442 \u043f\u0440\u043e\u0441\u043c\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044c \u0442\u043e\u043b\u044c\u043a\u043e \u0432\u043b\u0430\u0434\u0435\u043b\u0435\u0446 \u0438 \u043f\u043e\u0448\u0430\u0440\u0435\u043d\u043d\u044b\u0435 \u0447\u043b\u0435\u043d\u044b \u0441\u0435\u043c\u044c\u0438.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Добавление питомца в свою безопасную зону.
     * @param petId Идентификатор питомца.
     * @param safeZoneId Идентификатор безопасной зоны.
     * @return Успешное выполнение.
     */
    addPetToSafeZone(petId: string, safeZoneId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/pet/{pet_id}/safe-zone/{safe_zone_id}";
        if (petId === undefined || petId === null)
            throw new Error("The parameter 'petId' must be defined.");
        url_ = url_.replace("{pet_id}", encodeURIComponent("" + petId));
        if (safeZoneId === undefined || safeZoneId === null)
            throw new Error("The parameter 'safeZoneId' must be defined.");
        url_ = url_.replace("{safe_zone_id}", encodeURIComponent("" + safeZoneId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAddPetToSafeZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPetToSafeZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddPetToSafeZone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("\n            \u0414\u043e\u0431\u0430\u0432\u043b\u044f\u0442\u044c \u043f\u0438\u0442\u043e\u043c\u0446\u0430 \u043c\u043e\u0436\u043d\u043e \u0442\u043e\u043b\u044c\u043a\u043e \u0432 \u0441\u0432\u043e\u044e \u0431\u0435\u0437\u043e\u043f\u0430\u0441\u043d\u0443\u044e \u0437\u043e\u043d\u0443.\n            \u0414\u043e\u0431\u0430\u0432\u043b\u044f\u0442\u044c \u043f\u0438\u0442\u043e\u043c\u0446\u0430 \u043c\u043e\u0436\u043d\u043e \u0442\u043e\u043b\u044c\u043a\u043e, \u0435\u0441\u043b\u0438 \u044d\u0442\u043e \u0441\u0432\u043e\u0439 \u043f\u0438\u0442\u043e\u043c\u0435\u0446 \u0438\u043b\u0438 \u043f\u043e\u0448\u0430\u0440\u0435\u043d\u043d\u044b\u0439.\n            ", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("\u041f\u0438\u0442\u043e\u043c\u0435\u0446 \u0438\u043b\u0438 \u0431\u0435\u0437\u043e\u043f\u0430\u0441\u043d\u0430\u044f \u0437\u043e\u043d\u0430 \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u044b.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Удаление питомца из своей безопасной зоны.
     * @param petId Идентификатор питомца.
     * @param safeZoneId Идентификатор безопасной зоны.
     * @return Успешное выполнение.
     */
    deletePetFromSafeZone(petId: string, safeZoneId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/pet/{pet_id}/safe-zone/{safe_zone_id}";
        if (petId === undefined || petId === null)
            throw new Error("The parameter 'petId' must be defined.");
        url_ = url_.replace("{pet_id}", encodeURIComponent("" + petId));
        if (safeZoneId === undefined || safeZoneId === null)
            throw new Error("The parameter 'safeZoneId' must be defined.");
        url_ = url_.replace("{safe_zone_id}", encodeURIComponent("" + safeZoneId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePetFromSafeZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePetFromSafeZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePetFromSafeZone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("\n            \u0415\u0441\u043b\u0438 \u0431\u0435\u0437\u043e\u043f\u0430\u0441\u043d\u0430\u044f \u0437\u043e\u043d\u0430 \u0441\u0432\u043e\u044f, \u0442\u043e \u043c\u043e\u0436\u043d\u043e \u0443\u0434\u0430\u043b\u044f\u0442\u044c \u0442\u043e\u043b\u044c\u043a\u043e \u0441\u0432\u043e\u0438\u0445 \u0438 \u043f\u043e\u0448\u0430\u0440\u0435\u043d\u043d\u044b\u0445 \u043f\u0438\u0442\u043e\u043c\u0446\u0435\u0432.\n            \u0415\u0441\u043b\u0438 \u0431\u0435\u0437\u043e\u043f\u0430\u0441\u043d\u0430\u044f \u0437\u043e\u043d\u0430 \u0447\u0443\u0436\u0430\u044f, \u0442\u043e \u043c\u043e\u0436\u043d\u043e \u0443\u0434\u0430\u043b\u044f\u0442\u044c \u0442\u043e\u043b\u044c\u043a\u043e \u0441\u0432\u043e\u0438\u0445 \u043f\u0438\u0442\u043e\u043c\u0446\u0435\u0432.\n            ", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("\u041f\u0438\u0442\u043e\u043c\u0435\u0446 \u0438\u043b\u0438 \u0431\u0435\u0437\u043e\u043f\u0430\u0441\u043d\u0430\u044f \u0437\u043e\u043d\u0430 \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u044b.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Обновить права к питомцу для указанного пользователя
     * @param petId (optional)
     * @param userId (optional)
     * @param level (optional)
     */
    changeShare(petId: string | undefined, userId: string | undefined, level: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/pet/change-share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (petId === null || petId === undefined)
            throw new Error("The parameter 'petId' cannot be null.");
        else
            content_.append("PetId", petId.toString());
        if (userId === null || userId === undefined)
            throw new Error("The parameter 'userId' cannot be null.");
        else
            content_.append("UserId", userId.toString());
        if (level !== null && level !== undefined)
            content_.append("Level", level.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processChangeShare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeShare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeShare(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Отозвать доступ к своему питомцу для указанного пользователя
     * @param petId Идентификатор питомца
     * @param targetUserId Идентификатор пользователя, у которого необходимо отозвать доступ
     * @return Успешное выполнение
     */
    unsharePet(petId: string, targetUserId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/pet/{pet_id}/user/{target_user_id}";
        if (petId === undefined || petId === null)
            throw new Error("The parameter 'petId' must be defined.");
        url_ = url_.replace("{pet_id}", encodeURIComponent("" + petId));
        if (targetUserId === undefined || targetUserId === null)
            throw new Error("The parameter 'targetUserId' must be defined.");
        url_ = url_.replace("{target_user_id}", encodeURIComponent("" + targetUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUnsharePet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnsharePet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnsharePet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DevicePublicClient extends PublicClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(CustomerStore) configuration: CustomerStore, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_PUBLIC) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44310";
    }

    /**
     * Получение истории обновления прошивок устройства.
     * @param deviceId Идентификатор устройства.
     * @param page (optional) Номер страницы (по умолчанию 1).
     * @param perPage (optional) Размер страницы (по умолчанию 10).
     * @return Возвращает историю обновления прошивок устройства.
     */
    getDeviceFirmwares(deviceId: string, page: number | null | undefined, perPage: number | null | undefined): Observable<PagedListOfFirmwareHistoryListItemDto> {
        let url_ = this.baseUrl + "/api/mobile/device/{device_id}/firmware?";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{device_id}", encodeURIComponent("" + deviceId));
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage !== undefined && perPage !== null)
            url_ += "per_page=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDeviceFirmwares(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeviceFirmwares(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfFirmwareHistoryListItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfFirmwareHistoryListItemDto>;
        }));
    }

    protected processGetDeviceFirmwares(response: HttpResponseBase): Observable<PagedListOfFirmwareHistoryListItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfFirmwareHistoryListItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Привязка устройства к питомцу.
     * @param deviceId Идентификатор устройства.
     * @param pet_id (optional)
     */
    attachDevice(deviceId: string, pet_id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/device/{device_id}/action/attach";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{device_id}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (pet_id === null || pet_id === undefined)
            throw new Error("The parameter 'pet_id' cannot be null.");
        else
            content_.append("pet_id", pet_id.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAttachDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAttachDevice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("\u0423\u0441\u0442\u0440\u043e\u0439\u0441\u0442\u0432\u043e \u0438\u043b\u0438 \u043f\u0438\u0442\u043e\u043c\u0435\u0446 \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d.", status, _responseText, _headers, result404);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("\u0423\u0441\u0442\u0440\u043e\u0439\u0441\u0442\u0432\u043e \u0443\u0436\u0435 \u043f\u0440\u0438\u0432\u044f\u0437\u0430\u043d\u043e \u043a \u0434\u0440\u0443\u0433\u043e\u043c\u0443 \u043f\u0438\u0442\u043e\u043c\u0446\u0443 \u0438\u043b\u0438 \u0442\u0435\u043a\u0443\u0449\u0438\u0439 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044c \u043d\u0435 \u044f\u0432\u043b\u044f\u0435\u0442\u0441\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0435\u043c \u043f\u0438\u0442\u043e\u043c\u0446\u0430.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Отвязка устройства от питомца.
     * @param deviceId Идентификатор устройства.
     * @return Успешное выполнение.
     */
    detachDevice(deviceId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/device/{device_id}/action/detach";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{device_id}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDetachDevice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetachDevice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDetachDevice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("\u0422\u0435\u043a\u0443\u0449\u0438\u0439 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044c \u043d\u0435 \u044f\u0432\u043b\u044f\u0435\u0442\u0441\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0435\u043c \u043f\u0438\u0442\u043e\u043c\u0446\u0430.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("\u0423\u0441\u0442\u0440\u043e\u0439\u0441\u0442\u0432\u043e \u0438\u043b\u0438 \u043f\u0438\u0442\u043e\u043c\u0435\u0446 \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Отправка команды Lost на устройство.
     * @param deviceId Идентификатор устройства.
     * @param enable (optional)
     * @return Успешное выполнение.
     */
    sendLostCommand(deviceId: string, enable: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/device/{device_id}/command/lost";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{device_id}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (enable === null || enable === undefined)
            throw new Error("The parameter 'enable' cannot be null.");
        else
            content_.append("enable", enable.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSendLostCommand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendLostCommand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendLostCommand(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("\u041a\u043e\u043c\u0430\u043d\u0434\u0430 \u043d\u0435 \u043c\u043e\u0436\u0435\u0442 \u0431\u044b\u0442\u044c \u043e\u0442\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0430.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Отправка команды off leash на устройство.
     * @param deviceId Идентификатор устройства.
     * @param enable (optional)
     * @return Успешное выполнение.
     */
    sendOffLeashCommand(deviceId: string, enable: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/device/{device_id}/command/off-leash";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{device_id}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (enable === null || enable === undefined)
            throw new Error("The parameter 'enable' cannot be null.");
        else
            content_.append("enable", enable.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSendOffLeashCommand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendOffLeashCommand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendOffLeashCommand(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("\u0423\u0441\u0442\u0440\u043e\u0439\u0441\u0442\u0432\u043e \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u043e.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Switch GPS mode on the collar.
     * @param collarId Collar identifier.
     * @param mode (optional)
     * @return Success.
     */
    switchGpsMode(collarId: string, mode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/device/{collar_id}/switch-gps";
        if (collarId === undefined || collarId === null)
            throw new Error("The parameter 'collarId' must be defined.");
        url_ = url_.replace("{collar_id}", encodeURIComponent("" + collarId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (mode !== null && mode !== undefined)
            content_.append("mode", mode.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSwitchGpsMode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchGpsMode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSwitchGpsMode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Collar not found.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Switch GSM profile on the collar.
     * @param collarId Collar identifier.
     * @param profile (optional)
     * @return Success.
     */
    switchGsmProfile(collarId: string, profile: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/device/{collar_id}/switch-gsm-profile";
        if (collarId === undefined || collarId === null)
            throw new Error("The parameter 'collarId' must be defined.");
        url_ = url_.replace("{collar_id}", encodeURIComponent("" + collarId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (profile !== null && profile !== undefined)
            content_.append("profile", profile.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSwitchGsmProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchGsmProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSwitchGsmProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Collar not found.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Не выключать модем даже во время сна
     * @param collarId Идентификатор устройства.
     * @param enable (optional)
     * @return Успешное выполнение.
     */
    setAlwaysOnline(collarId: string, enable: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/device/{collar_id}/command/always-online";
        if (collarId === undefined || collarId === null)
            throw new Error("The parameter 'collarId' must be defined.");
        url_ = url_.replace("{collar_id}", encodeURIComponent("" + collarId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (enable === null || enable === undefined)
            throw new Error("The parameter 'enable' cannot be null.");
        else
            content_.append("enable", enable.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetAlwaysOnline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAlwaysOnline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAlwaysOnline(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("\u0423\u0441\u0442\u0440\u043e\u0439\u0441\u0442\u0432\u043e \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u043e.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Не выключать GPS даже во время сна
     * @param collarId Идентификатор устройства.
     * @param enable (optional)
     * @return Успешное выполнение.
     */
    setGPSOnForever(collarId: string, enable: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/device/{collar_id}/command/gps-on-forever";
        if (collarId === undefined || collarId === null)
            throw new Error("The parameter 'collarId' must be defined.");
        url_ = url_.replace("{collar_id}", encodeURIComponent("" + collarId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (enable === null || enable === undefined)
            throw new Error("The parameter 'enable' cannot be null.");
        else
            content_.append("enable", enable.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetGPSOnForever(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetGPSOnForever(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetGPSOnForever(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("\u0423\u0441\u0442\u0440\u043e\u0439\u0441\u0442\u0432\u043e \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u043e.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Настройка порогов для уведомлений о температуре.
     * @param collarId Идентификатор устройства.
     * @param lower (optional)
     * @param upper (optional)
     * @return Успешное выполнение.
     */
    changeTemperatureAlerts(collarId: string, lower: number | undefined, upper: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/device/{collar_id}/temperature-alerts";
        if (collarId === undefined || collarId === null)
            throw new Error("The parameter 'collarId' must be defined.");
        url_ = url_.replace("{collar_id}", encodeURIComponent("" + collarId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (lower === null || lower === undefined)
            throw new Error("The parameter 'lower' cannot be null.");
        else
            content_.append("lower", lower.toString());
        if (upper === null || upper === undefined)
            throw new Error("The parameter 'upper' cannot be null.");
        else
            content_.append("upper", upper.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processChangeTemperatureAlerts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeTemperatureAlerts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeTemperatureAlerts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("\u0423\u0441\u0442\u0440\u043e\u0439\u0441\u0442\u0432\u043e \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u043e.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Отправка команды Energy Saving на устройство.
     * @param deviceId Идентификатор устройства.
     * @param enable (optional)
     * @return Успешное выполнение.
     */
    sendEnergySavingCommand(deviceId: string, enable: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/device/{device_id}/command/energy-saving";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{device_id}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (enable === null || enable === undefined)
            throw new Error("The parameter 'enable' cannot be null.");
        else
            content_.append("enable", enable.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSendEnergySavingCommand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEnergySavingCommand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEnergySavingCommand(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("\u0423\u0441\u0442\u0440\u043e\u0439\u0441\u0442\u0432\u043e \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u043e.", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("\u041a\u043e\u043c\u0430\u043d\u0434\u0430 \u043d\u0435 \u043c\u043e\u0436\u0435\u0442 \u0431\u044b\u0442\u044c \u043e\u0442\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0430.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Отправка команды Request Coordinates на устройство.
     * @param deviceId Идентификатор устройства.
     * @return Успешное выполнение.
     */
    sendRequestCoordinatesCommand(deviceId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/device/{device_id}/command/request-coordinates";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{device_id}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSendRequestCoordinatesCommand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendRequestCoordinatesCommand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendRequestCoordinatesCommand(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("\u0423\u0441\u0442\u0440\u043e\u0439\u0441\u0442\u0432\u043e \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u043e.", status, _responseText, _headers, result404);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = ProblemDetails.fromJS(resultData422);
            return throwException("\u041a\u043e\u043c\u0430\u043d\u0434\u0430 \u043d\u0435 \u043c\u043e\u0436\u0435\u0442 \u0431\u044b\u0442\u044c \u043e\u0442\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0430.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DevicesPublicClient extends PublicClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(CustomerStore) configuration: CustomerStore, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_PUBLIC) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44310";
    }

    /**
     * Getting all user devices for widget (collars, ble beacons, flashlights)
     * @return User's devices
     */
    getWidgetDevices(): Observable<WidgetDevice> {
        let url_ = this.baseUrl + "/api/mobile/devices/widget";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWidgetDevices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWidgetDevices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WidgetDevice>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WidgetDevice>;
        }));
    }

    protected processGetWidgetDevices(response: HttpResponseBase): Observable<WidgetDevice> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WidgetDevice.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update beacon charge.
     * @param mac_address (optional)
     * @param tx_power (optional)
     * @param voltage (optional)
     */
    updateBeacon(mac_address: string | null | undefined, tx_power: SByte | undefined, voltage: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/devices/beacons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (mac_address !== null && mac_address !== undefined)
            content_.append("mac_address", mac_address.toString());
        if (tx_power === null || tx_power === undefined)
            throw new Error("The parameter 'tx_power' cannot be null.");
        else
            content_.append("tx_power", JSON.stringify(tx_power));
        if (voltage === null || voltage === undefined)
            throw new Error("The parameter 'voltage' cannot be null.");
        else
            content_.append("voltage", voltage.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateBeacon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBeacon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBeacon(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update flashlight location.
     * @param mac_address (optional)
     * @param lng (optional)
     * @param lat (optional)
     * @param charge (optional)
     */
    updateFlashlight(mac_address: string | null | undefined, lng: number | undefined, lat: number | undefined, charge: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/devices/flashlights";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (mac_address !== null && mac_address !== undefined)
            content_.append("mac_address", mac_address.toString());
        if (lng === null || lng === undefined)
            throw new Error("The parameter 'lng' cannot be null.");
        else
            content_.append("lng", lng.toString());
        if (lat === null || lat === undefined)
            throw new Error("The parameter 'lat' cannot be null.");
        else
            content_.append("lat", lat.toString());
        if (charge === null || charge === undefined)
            throw new Error("The parameter 'charge' cannot be null.");
        else
            content_.append("charge", charge.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateFlashlight(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFlashlight(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFlashlight(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FlashlightPublicClient extends PublicClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(CustomerStore) configuration: CustomerStore, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_PUBLIC) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44310";
    }

    /**
     * Turn off/on/auto flashlight
     * @param device_id (optional)
     * @param petId (optional)
     * @param status (optional)
     */
    switch(device_id: string | null | undefined, petId: string | null | undefined, status: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/flashlight";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (device_id !== null && device_id !== undefined)
            content_.append("device_id", device_id.toString());
        if (petId !== null && petId !== undefined)
            content_.append("PetId", petId.toString());
        if (status !== null && status !== undefined)
            content_.append("Status", status.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSwitch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSwitch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Link flashlight to collar
     * @param macAddress (optional)
     * @param petId (optional)
     * @param holderColor (optional)
     * @return Successful binding
     */
    link(macAddress: string | null | undefined, petId: string | undefined, holderColor: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/flashlight/link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (macAddress !== null && macAddress !== undefined)
            content_.append("MacAddress", macAddress.toString());
        if (petId === null || petId === undefined)
            throw new Error("The parameter 'petId' cannot be null.");
        else
            content_.append("PetId", petId.toString());
        if (holderColor !== null && holderColor !== undefined)
            content_.append("HolderColor", holderColor.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Unlink flashlight from collar
     * @param macAddress (optional)
     * @return Successful binding
     */
    unlink(macAddress: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/flashlight/unlink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (macAddress !== null && macAddress !== undefined)
            content_.append("MacAddress", macAddress.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUnlink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Configure flashlight settings
     * @param petId (optional)
     * @param animation (optional)
     * @param lostAnimation (optional)
     * @param speed (optional)
     * @param brightness (optional)
     * @param customColor (optional)
     * @param creepingLine (optional)
     * @param useMorse (optional)
     * @param showBleState (optional)
     */
    configure(petId: string | undefined, animation: number | null | undefined, lostAnimation: number | null | undefined, speed: number | null | undefined, brightness: number | null | undefined, customColor: string | null | undefined, creepingLine: string | null | undefined, useMorse: boolean | null | undefined, showBleState: boolean | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/flashlight/configure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (petId === null || petId === undefined)
            throw new Error("The parameter 'petId' cannot be null.");
        else
            content_.append("PetId", petId.toString());
        if (animation !== null && animation !== undefined)
            content_.append("Animation", animation.toString());
        if (lostAnimation !== null && lostAnimation !== undefined)
            content_.append("LostAnimation", lostAnimation.toString());
        if (speed !== null && speed !== undefined)
            content_.append("Speed", speed.toString());
        if (brightness !== null && brightness !== undefined)
            content_.append("Brightness", brightness.toString());
        if (customColor !== null && customColor !== undefined)
            content_.append("CustomColor", customColor.toString());
        if (creepingLine !== null && creepingLine !== undefined)
            content_.append("CreepingLine", creepingLine.toString());
        if (useMorse !== null && useMorse !== undefined)
            content_.append("UseMorse", useMorse.toString());
        if (showBleState !== null && showBleState !== undefined)
            content_.append("ShowBleState", showBleState.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processConfigure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfigure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfigure(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get firmware changelog
     * @param macAddress Flashlight MAC address
     * @param page (optional) Page number
     * @param perPage (optional) Page size
     */
    getFirmwaresChangelog(macAddress: string, page: number | undefined, perPage: number | undefined): Observable<PagedListOfFirmwareHistoryListItemDto> {
        let url_ = this.baseUrl + "/api/mobile/flashlight/{mac_address}/changelog?";
        if (macAddress === undefined || macAddress === null)
            throw new Error("The parameter 'macAddress' must be defined.");
        url_ = url_.replace("{mac_address}", encodeURIComponent("" + macAddress));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage === null)
            throw new Error("The parameter 'perPage' cannot be null.");
        else if (perPage !== undefined)
            url_ += "per_page=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFirmwaresChangelog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirmwaresChangelog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfFirmwareHistoryListItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfFirmwareHistoryListItemDto>;
        }));
    }

    protected processGetFirmwaresChangelog(response: HttpResponseBase): Observable<PagedListOfFirmwareHistoryListItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfFirmwareHistoryListItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Download last firmware
     */
    downloadFirmware(macAddress: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/mobile/flashlight/{mac_address}/firmware";
        if (macAddress === undefined || macAddress === null)
            throw new Error("The parameter 'macAddress' must be defined.");
        url_ = url_.replace("{mac_address}", encodeURIComponent("" + macAddress));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDownloadFirmware(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFirmware(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadFirmware(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OnboardingPublicClient extends PublicClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(CustomerStore) configuration: CustomerStore, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_PUBLIC) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44310";
    }

    /**
     * Сохранение данных онбординга
     * @param device_id (optional)
     * @param pet_safe_zones (optional)
     * @param pet_AddSafeZones (optional)
     * @param pet_Alias (optional)
     * @param pet_FullName (optional)
     * @param pet_Sex (optional)
     * @param pet_breed_id (optional)
     * @param pet_birth_date (optional)
     * @param pet_Note (optional)
     * @param pet_Weight (optional)
     * @param pet_Height (optional)
     * @param pet_Goal (optional)
     * @param pet_avatar_file (optional)
     * @param pet_StepDistanceRatio (optional)
     * @param pet_RunDistanceRatio (optional)
     * @param pet_GallopDistanceRatio (optional)
     * @param user_FirstName (optional)
     * @param user_LastName (optional)
     * @param user_Sex (optional)
     * @param user_Phone (optional)
     * @param user_Note (optional)
     * @param user_DistanceMeasurement (optional)
     * @param user_WeightMeasurement (optional)
     * @param user_TemperatureMeasurement (optional)
     * @param user_TimeFormat (optional)
     * @param user_avatar_file (optional)
     * @param user_Privacy_PetViewLevel (optional)
     * @param user_Privacy_TrackViewLevel (optional)
     * @param safe_zone_Title (optional)
     * @param safe_zone_Coord (optional)
     * @param safe_zone_ble_beacons (optional)
     * @param safe_zone_name (optional)
     * @param safe_zone_polygon (optional)
     * @param safe_zone_access_points (optional)
     * @param safe_zone_beacons (optional)
     * @param safe_zone_include_pets (optional)
     */
    save(device_id: string | null | undefined, pet_safe_zones: string[] | null | undefined, pet_AddSafeZones: boolean | null | undefined, pet_Alias: string | null | undefined, pet_FullName: string | null | undefined, pet_Sex: string | null | undefined, pet_breed_id: string | null | undefined, pet_birth_date: string | null | undefined, pet_Note: string | null | undefined, pet_Weight: number | null | undefined, pet_Height: number | null | undefined, pet_Goal: number | null | undefined, pet_avatar_file: FileParameter | null | undefined, pet_StepDistanceRatio: number | null | undefined, pet_RunDistanceRatio: number | null | undefined, pet_GallopDistanceRatio: number | null | undefined, user_FirstName: string | null | undefined, user_LastName: string | null | undefined, user_Sex: string | null | undefined, user_Phone: string | null | undefined, user_Note: string | null | undefined, user_DistanceMeasurement: string | null | undefined, user_WeightMeasurement: string | null | undefined, user_TemperatureMeasurement: string | null | undefined, user_TimeFormat: string | null | undefined, user_avatar_file: FileParameter | null | undefined, user_Privacy_PetViewLevel: string | null | undefined, user_Privacy_TrackViewLevel: string | null | undefined, safe_zone_Title: string | null | undefined, safe_zone_Coord: string | null | undefined, safe_zone_ble_beacons: AddBeacon[] | null | undefined, safe_zone_name: string | null | undefined, safe_zone_polygon: string | null | undefined, safe_zone_access_points: AddAccessPoint[] | null | undefined, safe_zone_beacons: AddBeacon[] | null | undefined, safe_zone_include_pets: boolean | undefined): Observable<OnboardingResult> {
        let url_ = this.baseUrl + "/api/mobile/onboarding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (device_id !== null && device_id !== undefined)
            content_.append("device_id", device_id.toString());
        if (pet_safe_zones !== null && pet_safe_zones !== undefined)
            pet_safe_zones.forEach(item_ => content_.append("pet.safe_zones", item_.toString()));
        if (pet_AddSafeZones !== null && pet_AddSafeZones !== undefined)
            content_.append("pet.AddSafeZones", pet_AddSafeZones.toString());
        if (pet_Alias !== null && pet_Alias !== undefined)
            content_.append("pet.Alias", pet_Alias.toString());
        if (pet_FullName !== null && pet_FullName !== undefined)
            content_.append("pet.FullName", pet_FullName.toString());
        if (pet_Sex !== null && pet_Sex !== undefined)
            content_.append("pet.Sex", pet_Sex.toString());
        if (pet_breed_id !== null && pet_breed_id !== undefined)
            content_.append("pet.breed_id", pet_breed_id.toString());
        if (pet_birth_date !== null && pet_birth_date !== undefined)
            content_.append("pet.birth_date", pet_birth_date.toString());
        if (pet_Note !== null && pet_Note !== undefined)
            content_.append("pet.Note", pet_Note.toString());
        if (pet_Weight !== null && pet_Weight !== undefined)
            content_.append("pet.Weight", pet_Weight.toString());
        if (pet_Height !== null && pet_Height !== undefined)
            content_.append("pet.Height", pet_Height.toString());
        if (pet_Goal !== null && pet_Goal !== undefined)
            content_.append("pet.Goal", pet_Goal.toString());
        if (pet_avatar_file !== null && pet_avatar_file !== undefined)
            content_.append("pet.avatar_file", pet_avatar_file.data, pet_avatar_file.fileName ? pet_avatar_file.fileName : "pet.avatar_file");
        if (pet_StepDistanceRatio !== null && pet_StepDistanceRatio !== undefined)
            content_.append("pet.StepDistanceRatio", pet_StepDistanceRatio.toString());
        if (pet_RunDistanceRatio !== null && pet_RunDistanceRatio !== undefined)
            content_.append("pet.RunDistanceRatio", pet_RunDistanceRatio.toString());
        if (pet_GallopDistanceRatio !== null && pet_GallopDistanceRatio !== undefined)
            content_.append("pet.GallopDistanceRatio", pet_GallopDistanceRatio.toString());
        if (user_FirstName !== null && user_FirstName !== undefined)
            content_.append("user.FirstName", user_FirstName.toString());
        if (user_LastName !== null && user_LastName !== undefined)
            content_.append("user.LastName", user_LastName.toString());
        if (user_Sex !== null && user_Sex !== undefined)
            content_.append("user.Sex", user_Sex.toString());
        if (user_Phone !== null && user_Phone !== undefined)
            content_.append("user.Phone", user_Phone.toString());
        if (user_Note !== null && user_Note !== undefined)
            content_.append("user.Note", user_Note.toString());
        if (user_DistanceMeasurement !== null && user_DistanceMeasurement !== undefined)
            content_.append("user.DistanceMeasurement", user_DistanceMeasurement.toString());
        if (user_WeightMeasurement !== null && user_WeightMeasurement !== undefined)
            content_.append("user.WeightMeasurement", user_WeightMeasurement.toString());
        if (user_TemperatureMeasurement !== null && user_TemperatureMeasurement !== undefined)
            content_.append("user.TemperatureMeasurement", user_TemperatureMeasurement.toString());
        if (user_TimeFormat !== null && user_TimeFormat !== undefined)
            content_.append("user.TimeFormat", user_TimeFormat.toString());
        if (user_avatar_file !== null && user_avatar_file !== undefined)
            content_.append("user.avatar_file", user_avatar_file.data, user_avatar_file.fileName ? user_avatar_file.fileName : "user.avatar_file");
        if (user_Privacy_PetViewLevel !== null && user_Privacy_PetViewLevel !== undefined)
            content_.append("user.Privacy.PetViewLevel", user_Privacy_PetViewLevel.toString());
        if (user_Privacy_TrackViewLevel !== null && user_Privacy_TrackViewLevel !== undefined)
            content_.append("user.Privacy.TrackViewLevel", user_Privacy_TrackViewLevel.toString());
        if (safe_zone_Title !== null && safe_zone_Title !== undefined)
            content_.append("safe_zone.Title", safe_zone_Title.toString());
        if (safe_zone_Coord !== null && safe_zone_Coord !== undefined)
            content_.append("safe_zone.Coord", safe_zone_Coord.toString());
        if (safe_zone_ble_beacons !== null && safe_zone_ble_beacons !== undefined)
            safe_zone_ble_beacons.forEach(item_ => content_.append("safe_zone.ble_beacons", item_.toString()));
        if (safe_zone_name !== null && safe_zone_name !== undefined)
            content_.append("safe_zone.name", safe_zone_name.toString());
        if (safe_zone_polygon !== null && safe_zone_polygon !== undefined)
            content_.append("safe_zone.polygon", safe_zone_polygon.toString());
        if (safe_zone_access_points !== null && safe_zone_access_points !== undefined)
            safe_zone_access_points.forEach(item_ => content_.append("safe_zone.access_points", item_.toString()));
        if (safe_zone_beacons !== null && safe_zone_beacons !== undefined)
            safe_zone_beacons.forEach(item_ => content_.append("safe_zone.beacons", item_.toString()));
        if (safe_zone_include_pets === null || safe_zone_include_pets === undefined)
            throw new Error("The parameter 'safe_zone_include_pets' cannot be null.");
        else
            content_.append("safe_zone.include_pets", safe_zone_include_pets.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnboardingResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnboardingResult>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<OnboardingResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnboardingResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserPublicClient extends PublicClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(CustomerStore) configuration: CustomerStore, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_PUBLIC) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44310";
    }

    /**
     * Получение профиля пользователя
     * @param userId Идентификатор пользователя
     * @return Возвращает профиль пользователя
     */
    getUserProfile(userId: string): Observable<Customer> {
        let url_ = this.baseUrl + "/api/mobile/user/{user_id}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{user_id}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Customer>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Customer>;
        }));
    }

    protected processGetUserProfile(response: HttpResponseBase): Observable<Customer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Customer.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("\u041f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044c \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Обновление профиля пользователя.
     * @param firstName (optional)
     * @param lastName (optional)
     * @param sex (optional)
     * @param phone (optional)
     * @param note (optional)
     * @param distanceMeasurement (optional)
     * @param weightMeasurement (optional)
     * @param temperatureMeasurement (optional)
     * @param timeFormat (optional)
     * @param avatar_file (optional)
     * @param privacy_PetViewLevel (optional)
     * @param privacy_TrackViewLevel (optional)
     * @return Возвращает обновленный профиль пользователя.
     */
    updateUser(firstName: string | null | undefined, lastName: string | null | undefined, sex: string | null | undefined, phone: string | null | undefined, note: string | null | undefined, distanceMeasurement: string | null | undefined, weightMeasurement: string | null | undefined, temperatureMeasurement: string | null | undefined, timeFormat: string | null | undefined, avatar_file: FileParameter | null | undefined, privacy_PetViewLevel: string | null | undefined, privacy_TrackViewLevel: string | null | undefined): Observable<CustomerPrivate> {
        let url_ = this.baseUrl + "/api/mobile/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (firstName !== null && firstName !== undefined)
            content_.append("FirstName", firstName.toString());
        if (lastName !== null && lastName !== undefined)
            content_.append("LastName", lastName.toString());
        if (sex !== null && sex !== undefined)
            content_.append("Sex", sex.toString());
        if (phone !== null && phone !== undefined)
            content_.append("Phone", phone.toString());
        if (note !== null && note !== undefined)
            content_.append("Note", note.toString());
        if (distanceMeasurement !== null && distanceMeasurement !== undefined)
            content_.append("DistanceMeasurement", distanceMeasurement.toString());
        if (weightMeasurement !== null && weightMeasurement !== undefined)
            content_.append("WeightMeasurement", weightMeasurement.toString());
        if (temperatureMeasurement !== null && temperatureMeasurement !== undefined)
            content_.append("TemperatureMeasurement", temperatureMeasurement.toString());
        if (timeFormat !== null && timeFormat !== undefined)
            content_.append("TimeFormat", timeFormat.toString());
        if (avatar_file !== null && avatar_file !== undefined)
            content_.append("avatar_file", avatar_file.data, avatar_file.fileName ? avatar_file.fileName : "avatar_file");
        if (privacy_PetViewLevel !== null && privacy_PetViewLevel !== undefined)
            content_.append("Privacy.PetViewLevel", privacy_PetViewLevel.toString());
        if (privacy_TrackViewLevel !== null && privacy_TrackViewLevel !== undefined)
            content_.append("Privacy.TrackViewLevel", privacy_TrackViewLevel.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerPrivate>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerPrivate>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<CustomerPrivate> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerPrivate.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("\u041e\u0448\u0438\u0431\u043a\u0438 \u043f\u0440\u0438 \u0437\u0430\u043f\u043e\u043b\u043d\u0435\u043d\u0438\u0438 \u0444\u043e\u0440\u043c\u044b.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Удаление текущего пользователя из системы
     * @param confirmationCode (optional)
     * @return Возвращает код подтверждения если он не был указан в запросе.
     */
    deleteUser(confirmationCode: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/mobile/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (confirmationCode !== null && confirmationCode !== undefined)
            content_.append("ConfirmationCode", confirmationCode.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("\u0423\u0441\u043f\u0435\u0448\u043d\u043e\u0435 \u0443\u0434\u0430\u043b\u0435\u043d\u0438\u0435.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("\u041f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044c \u0438\u043c\u0435\u0435\u0442 \u0430\u043a\u0442\u0438\u0432\u043d\u044b\u0435 \u043f\u043e\u0434\u043f\u0438\u0441\u043a\u0438.", status, _responseText, _headers, result409);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("\u041a\u043e\u0434 \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u044f \u043d\u0435\u0432\u0435\u0440\u043d\u044b\u0439.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    getUserProfile2(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/mobile/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserProfile2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserProfile2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetUserProfile2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the user's avatar
     */
    deleteAvatar(): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/user/avatar";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteAvatar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAvatar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAvatar(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Список уведомлений текущего пользователя.
     * @param petIds (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @param timezone (optional)
     * @param from (optional)
     * @param limit (optional)
     */
    getFeed(petIds: string[] | null | undefined, startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, timezone: string | null | undefined, from: moment.Moment | null | undefined, limit: number | null | undefined): Observable<FlowListOfFeed> {
        let url_ = this.baseUrl + "/api/mobile/user/feed?";
        if (petIds !== undefined && petIds !== null)
            petIds && petIds.forEach(item => { url_ += "pets=" + encodeURIComponent("" + item) + "&"; });
        if (startDate !== undefined && startDate !== null)
            url_ += "start_date=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "end_date=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (timezone !== undefined && timezone !== null)
            url_ += "timezone=" + encodeURIComponent("" + timezone) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFeed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FlowListOfFeed>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FlowListOfFeed>;
        }));
    }

    protected processGetFeed(response: HttpResponseBase): Observable<FlowListOfFeed> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FlowListOfFeed.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Обновление настроек уведомлений текущего пользователя.
     * @param items (optional)
     */
    updateNotificationSettings(items: { [key in keyof typeof NotificationGroupType]?: DeliveryTypeFlags; } | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/user/notification-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (items !== null && items !== undefined)
            content_.append("Items", JSON.stringify(items));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNotificationSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("\u041f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044c \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @deprecated
     */
    getNotificationSettings(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/mobile/user/notification-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetNotificationSettings(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BillingPublicClient extends PublicClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(CustomerStore) configuration: CustomerStore, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_PUBLIC) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44310";
    }

    /**
     * Список планов подписки
     * @param petId (optional)
     */
    getSubscriptionPlans(petId: string | undefined): Observable<SubscriptionPrice[]> {
        let url_ = this.baseUrl + "/api/mobile/billing/plans?";
        if (petId === null)
            throw new Error("The parameter 'petId' cannot be null.");
        else if (petId !== undefined)
            url_ += "pet_id=" + encodeURIComponent("" + petId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubscriptionPlans(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionPlans(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionPrice[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionPrice[]>;
        }));
    }

    protected processGetSubscriptionPlans(response: HttpResponseBase): Observable<SubscriptionPrice[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriptionPrice.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Список подписок пользователя
     */
    getSubscriptions(): Observable<Subscription[]> {
        let url_ = this.baseUrl + "/api/mobile/billing/subscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Subscription[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Subscription[]>;
        }));
    }

    protected processGetSubscriptions(response: HttpResponseBase): Observable<Subscription[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Subscription.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Обновление подписки пользователя
     * @param petId (optional)
     * @param priceId (optional)
     * @param paymentMethodId (optional)
     * @return Возвращает созданную подписку.
     */
    setSubscription(petId: string | undefined, priceId: string | null | undefined, paymentMethodId: string | null | undefined): Observable<Subscription> {
        let url_ = this.baseUrl + "/api/mobile/billing/subscriptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (petId === null || petId === undefined)
            throw new Error("The parameter 'petId' cannot be null.");
        else
            content_.append("PetId", petId.toString());
        if (priceId !== null && priceId !== undefined)
            content_.append("PriceId", priceId.toString());
        if (paymentMethodId !== null && paymentMethodId !== undefined)
            content_.append("PaymentMethodId", paymentMethodId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSetSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Subscription>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Subscription>;
        }));
    }

    protected processSetSubscription(response: HttpResponseBase): Observable<Subscription> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Subscription.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("\u0422\u0435\u043a\u0443\u0449\u0438\u0439 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044c \u043d\u0435 \u044f\u0432\u043b\u044f\u0435\u0442\u0441\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0435\u043c \u043f\u0438\u0442\u043e\u043c\u0446\u0430.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("\u041f\u0440\u0438\u0432\u044f\u0437\u0430\u043d\u043d\u043e\u0435 \u0443\u0441\u0442\u0440\u043e\u0439\u0441\u0442\u0432\u043e \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u043e.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("\u041f\u043b\u0430\u0442\u0435\u0436 \u0431\u044b\u043b \u043e\u0442\u043a\u043b\u043e\u043d\u0435\u043d.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Отмена подписки пользователя
     * @param petId (optional)
     * @return Подписка удалена.
     */
    cancelSubscription(petId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/billing/subscriptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (petId === null || petId === undefined)
            throw new Error("The parameter 'petId' cannot be null.");
        else
            content_.append("PetId", petId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCancelSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("\u0422\u0435\u043a\u0443\u0449\u0438\u0439 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044c \u043d\u0435 \u044f\u0432\u043b\u044f\u0435\u0442\u0441\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0435\u043c \u043f\u043e\u0434\u043f\u0438\u0441\u043a\u0438.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Список способов оплаты пользователя
     */
    getPaymentMethods(): Observable<PaymentMethod[]> {
        let url_ = this.baseUrl + "/api/mobile/billing/payment-methods";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPaymentMethods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentMethods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentMethod[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentMethod[]>;
        }));
    }

    protected processGetPaymentMethods(response: HttpResponseBase): Observable<PaymentMethod[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentMethod.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Удаление способа оплаты пользователя
     * @param paymentId (optional)
     * @return Способ оплаты удален.
     */
    deletePaymentMethod(paymentId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/billing/payment-methods";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (paymentId !== null && paymentId !== undefined)
            content_.append("PaymentId", paymentId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePaymentMethod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePaymentMethod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePaymentMethod(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ApplicationPublicClient extends PublicClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(CustomerStore) configuration: CustomerStore, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_PUBLIC) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44310";
    }

    /**
     * Обновление приложения пользователя.
     * @param pushToken (optional)
     */
    updateApplication(pushToken: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/mobile/application";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (pushToken !== null && pushToken !== undefined)
            content_.append("PushToken", pushToken.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUpdateApplication(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param pushToken (optional)
     * @deprecated
     */
    updateApplicationLegacy(id: string, pushToken: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/mobile/application/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (pushToken !== null && pushToken !== undefined)
            content_.append("PushToken", pushToken.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateApplicationLegacy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateApplicationLegacy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUpdateApplicationLegacy(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuthPublicClient extends PublicClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(CustomerStore) configuration: CustomerStore, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_PUBLIC) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44310";
    }

    /**
     * Вход (авторизация) пользователя.
     * @param login (optional)
     * @param password (optional)
     * @param pushToken (optional)
     * @return Возвращает авторизованного пользователя.
     */
    authenticate(login: string | null | undefined, password: string | null | undefined, pushToken: string | null | undefined): Observable<Token> {
        let url_ = this.baseUrl + "/api/mobile/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (login !== null && login !== undefined)
            content_.append("Login", login.toString());
        if (password !== null && password !== undefined)
            content_.append("Password", password.toString());
        if (pushToken !== null && pushToken !== undefined)
            content_.append("PushToken", pushToken.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Token>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Token>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<Token> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Token.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("\u041f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044c \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Вход (авторизация) пользователя через социальные сети, FB, Google,
     * @param provider (optional)
     * @param token (optional)
     * @param email (optional)
     * @param pushToken (optional)
     * @return Возвращает авторизованного пользователя.
     */
    externalLogin(provider: string | null | undefined, token: string | null | undefined, email: string | null | undefined, pushToken: string | null | undefined): Observable<Token> {
        let url_ = this.baseUrl + "/api/mobile/auth/external-login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (provider !== null && provider !== undefined)
            content_.append("Provider", provider.toString());
        if (token !== null && token !== undefined)
            content_.append("Token", token.toString());
        if (email !== null && email !== undefined)
            content_.append("Email", email.toString());
        if (pushToken !== null && pushToken !== undefined)
            content_.append("PushToken", pushToken.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExternalLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Token>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Token>;
        }));
    }

    protected processExternalLogin(response: HttpResponseBase): Observable<Token> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Token.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("\u041f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044c \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Регистрация нового пользователя.
     * @param email (optional)
     * @param password (optional)
     * @param firstName (optional)
     * @param lastName (optional)
     * @param sex (optional)
     * @param pushToken (optional)
     * @return Возвращает авторизованного пользователя.
     */
    register(email: string | null | undefined, password: string | null | undefined, firstName: string | null | undefined, lastName: string | null | undefined, sex: string | null | undefined, pushToken: string | null | undefined): Observable<Token> {
        let url_ = this.baseUrl + "/api/mobile/auth/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (email !== null && email !== undefined)
            content_.append("Email", email.toString());
        if (password !== null && password !== undefined)
            content_.append("Password", password.toString());
        if (firstName !== null && firstName !== undefined)
            content_.append("FirstName", firstName.toString());
        if (lastName !== null && lastName !== undefined)
            content_.append("LastName", lastName.toString());
        if (sex !== null && sex !== undefined)
            content_.append("Sex", sex.toString());
        if (pushToken !== null && pushToken !== undefined)
            content_.append("PushToken", pushToken.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Token>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Token>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<Token> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Token.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("\u041e\u0448\u0438\u0431\u043a\u0438 \u043f\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044f.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Подтверждение Email пользователя
     * @param email (optional)
     * @param token (optional)
     */
    confirmEmail(email: string | null | undefined, token: string | null | undefined): Observable<Token> {
        let url_ = this.baseUrl + "/api/mobile/auth/confirm-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (email !== null && email !== undefined)
            content_.append("Email", email.toString());
        if (token !== null && token !== undefined)
            content_.append("Token", token.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Token>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Token>;
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<Token> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Token.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Отправления кода, для подтверждения email
     * @param email (optional)
     */
    sendConfirmEmailCode(email: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/auth/send-confirm-email-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (email !== null && email !== undefined)
            content_.append("Email", email.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSendConfirmEmailCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConfirmEmailCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendConfirmEmailCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    forgotPassword(email: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/auth/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (email !== null && email !== undefined)
            content_.append("Email", email.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPassword(email: string | null | undefined, token: string | null | undefined, password: string | null | undefined, pushToken: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/auth/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (email !== null && email !== undefined)
            content_.append("Email", email.toString());
        if (token !== null && token !== undefined)
            content_.append("Token", token.toString());
        if (password !== null && password !== undefined)
            content_.append("Password", password.toString());
        if (pushToken !== null && pushToken !== undefined)
            content_.append("PushToken", pushToken.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeEmail(newEmail: string | null | undefined, password: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/auth/change-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (newEmail !== null && newEmail !== undefined)
            content_.append("NewEmail", newEmail.toString());
        if (password !== null && password !== undefined)
            content_.append("Password", password.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processChangeEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Подтверждение Email пользователя
     * @param token (optional)
     */
    confirmEmailChanged(token: string | null | undefined): Observable<Token> {
        let url_ = this.baseUrl + "/api/mobile/auth/confirm-email-changed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (token !== null && token !== undefined)
            content_.append("Token", token.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processConfirmEmailChanged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmailChanged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Token>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Token>;
        }));
    }

    protected processConfirmEmailChanged(response: HttpResponseBase): Observable<Token> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Token.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Отмена изменения почты
     */
    cancelEmailChange(): Observable<void> {
        let url_ = this.baseUrl + "/api/mobile/auth/cancel-email-changed";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCancelEmailChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelEmailChange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelEmailChange(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AchievementsPublicClient extends PublicClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(CustomerStore) configuration: CustomerStore, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_PUBLIC) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44310";
    }

    /**
     * Getting all pet/user achievements
     * @param petId (optional) Pet identifier
     * @return Pet/user achievements
     */
    getAchievements(petId: string | null | undefined): Observable<Achievement2[]> {
        let url_ = this.baseUrl + "/achievements?";
        if (petId !== undefined && petId !== null)
            url_ += "petId=" + encodeURIComponent("" + petId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAchievements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAchievements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Achievement2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Achievement2[]>;
        }));
    }

    protected processGetAchievements(response: HttpResponseBase): Observable<Achievement2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Achievement2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all achievement types description
     * @param page (optional)
     * @param perPage (optional)
     * @return Achievement types list
     * @deprecated
     */
    getAchievementTypesLegacy(page: number | null | undefined, perPage: number | null | undefined): Observable<PagedListOfAchievementTypeLegacy> {
        let url_ = this.baseUrl + "/api/mobile/achievements/get-types?";
        if (page !== undefined && page !== null)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (perPage !== undefined && perPage !== null)
            url_ += "per_page=" + encodeURIComponent("" + perPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAchievementTypesLegacy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAchievementTypesLegacy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedListOfAchievementTypeLegacy>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedListOfAchievementTypeLegacy>;
        }));
    }

    protected processGetAchievementTypesLegacy(response: HttpResponseBase): Observable<PagedListOfAchievementTypeLegacy> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedListOfAchievementTypeLegacy.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all achievement types description
     * @return Achievement types list
     */
    getAchievementTypes(): Observable<AchievementType[]> {
        let url_ = this.baseUrl + "/api/mobile/achievement-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAchievementTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAchievementTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AchievementType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AchievementType[]>;
        }));
    }

    protected processGetAchievementTypes(response: HttpResponseBase): Observable<AchievementType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AchievementType.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 304) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LogPublicClient extends PublicClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(CustomerStore) configuration: CustomerStore, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_PUBLIC) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44310";
    }

    list(directory: string | null): Observable<string> {
        let url_ = this.baseUrl + "/log/{directory}";
        if (directory === undefined || directory === null)
            throw new Error("The parameter 'directory' must be defined.");
        url_ = url_.replace("{directory}", encodeURIComponent("" + directory));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upload(contentType: string | null | undefined, contentDisposition: string | null | undefined, headers: any[] | null | undefined, length: number | undefined, name: string | null | undefined, fileName: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    download(fileName: string, directory: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/log/{directory}/{file_name}";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{file_name}", encodeURIComponent("" + fileName));
        if (directory === undefined || directory === null)
            throw new Error("The parameter 'directory' must be defined.");
        url_ = url_.replace("{directory}", encodeURIComponent("" + directory));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebhookPublicClient extends PublicClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(CustomerStore) configuration: CustomerStore, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_PUBLIC) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44310";
    }

    processKoreWebhook(request: ProcessKoreWebhook | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/webhooks/kore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProcessKoreWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessKoreWebhook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processProcessKoreWebhook(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    processStripeWebhook(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/webhooks/stripe";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProcessStripeWebhook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessStripeWebhook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processProcessStripeWebhook(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ProfilePartial implements IProfilePartial {
    id?: string;
    email?: string;
    first_name?: string;
    last_name?: string | undefined;
    full_name?: string;
    avatar?: string | undefined;

    constructor(data?: IProfilePartial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.first_name = _data["first_name"];
            this.last_name = _data["last_name"];
            this.full_name = _data["full_name"];
            this.avatar = _data["avatar"];
        }
    }

    static fromJS(data: any): ProfilePartial {
        data = typeof data === 'object' ? data : {};
        let result = new ProfilePartial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["first_name"] = this.first_name;
        data["last_name"] = this.last_name;
        data["full_name"] = this.full_name;
        data["avatar"] = this.avatar;
        return data;
    }
}

export interface IProfilePartial {
    id?: string;
    email?: string;
    first_name?: string;
    last_name?: string | undefined;
    full_name?: string;
    avatar?: string | undefined;
}

export class Profile extends ProfilePartial implements IProfile {
    sex?: Sex;
    note?: string | undefined;
    phone?: string | undefined;
    email_confirmed?: boolean;
    new_email?: string | undefined;
    weight_measurement?: MeasurementSystem;
    distance_measurement?: MeasurementSystem;
    temperature_measurement?: TemperatureScale;
    track_view_level?: TrackViewLevel;
    pet_view_level?: PetViewLevel;
    notification_settings?: NotificationSettings;
    invites?: Invite[];

    constructor(data?: IProfile) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sex = _data["sex"];
            this.note = _data["note"];
            this.phone = _data["phone"];
            this.email_confirmed = _data["email_confirmed"];
            this.new_email = _data["new_email"];
            this.weight_measurement = _data["weight_measurement"];
            this.distance_measurement = _data["distance_measurement"];
            this.temperature_measurement = _data["temperature_measurement"];
            this.track_view_level = _data["track_view_level"];
            this.pet_view_level = _data["pet_view_level"];
            this.notification_settings = _data["notification_settings"] ? NotificationSettings.fromJS(_data["notification_settings"]) : <any>undefined;
            if (Array.isArray(_data["invites"])) {
                this.invites = [] as any;
                for (let item of _data["invites"])
                    this.invites!.push(Invite.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Profile {
        data = typeof data === 'object' ? data : {};
        let result = new Profile();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sex"] = this.sex;
        data["note"] = this.note;
        data["phone"] = this.phone;
        data["email_confirmed"] = this.email_confirmed;
        data["new_email"] = this.new_email;
        data["weight_measurement"] = this.weight_measurement;
        data["distance_measurement"] = this.distance_measurement;
        data["temperature_measurement"] = this.temperature_measurement;
        data["track_view_level"] = this.track_view_level;
        data["pet_view_level"] = this.pet_view_level;
        data["notification_settings"] = this.notification_settings ? this.notification_settings.toJSON() : <any>undefined;
        if (Array.isArray(this.invites)) {
            data["invites"] = [];
            for (let item of this.invites)
                data["invites"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IProfile extends IProfilePartial {
    sex?: Sex;
    note?: string | undefined;
    phone?: string | undefined;
    email_confirmed?: boolean;
    new_email?: string | undefined;
    weight_measurement?: MeasurementSystem;
    distance_measurement?: MeasurementSystem;
    temperature_measurement?: TemperatureScale;
    track_view_level?: TrackViewLevel;
    pet_view_level?: PetViewLevel;
    notification_settings?: NotificationSettings;
    invites?: Invite[];
}

/** 0 = NotSet 1 = Male 2 = Female */
export enum Sex {
    NotSet = 0,
    Male = 1,
    Female = 2,
}

/** 0 = Metric 1 = Imperial */
export enum MeasurementSystem {
    Metric = 0,
    Imperial = 1,
}

/** 0 = Celsius 1 = Kelvin */
export enum TemperatureScale {
    Celsius = 0,
    Kelvin = 1,
}

/** 0 = Owner 2 = Friends 4 = Walkers */
export enum TrackViewLevel {
    Owner = 0,
    Friends = 2,
    Walkers = 4,
}

/** 0 = OwnerOnly 1 = Family 2 = FamilyFriendsWalkers 3 = Everyone 4 = FamilyFriends */
export enum PetViewLevel {
    OwnerOnly = 0,
    Family = 1,
    FamilyFriendsWalkers = 2,
    Everyone = 3,
    FamilyFriends = 4,
}

export class NotificationSettings implements INotificationSettings {
    push?: NotificationGroup[];
    email?: NotificationGroup[];

    constructor(data?: INotificationSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["push"])) {
                this.push = [] as any;
                for (let item of _data["push"])
                    this.push!.push(NotificationGroup.fromJS(item));
            }
            if (Array.isArray(_data["email"])) {
                this.email = [] as any;
                for (let item of _data["email"])
                    this.email!.push(NotificationGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationSettings {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.push)) {
            data["push"] = [];
            for (let item of this.push)
                data["push"].push(item.toJSON());
        }
        if (Array.isArray(this.email)) {
            data["email"] = [];
            for (let item of this.email)
                data["email"].push(item.toJSON());
        }
        return data;
    }
}

export interface INotificationSettings {
    push?: NotificationGroup[];
    email?: NotificationGroup[];
}

export class NotificationGroup implements INotificationGroup {
    name?: string;
    items?: NotificationItem[];

    constructor(data?: INotificationGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NotificationItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationGroup {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface INotificationGroup {
    name?: string;
    items?: NotificationItem[];
}

export class NotificationItem implements INotificationItem {
    id?: NotificationGroupType;
    name?: string;
    enabled?: boolean;

    constructor(data?: INotificationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): NotificationItem {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface INotificationItem {
    id?: NotificationGroupType;
    name?: string;
    enabled?: boolean;
}

/** 0 = CollarFirmware 1 = CollarBattery 2 = CollarTemperature 3 = PetLostMode 4 = PetAlarmMode 5 = PetSafeZones 6 = PetAdventures 7 = UserAchievements 8 = UserSubscriptions 9 = UserSharing 10 = BeaconBattery 11 = FlashlightBattery 65535 = System */
export enum NotificationGroupType {
    CollarFirmware = 0,
    CollarBattery = 1,
    CollarTemperature = 2,
    PetLostMode = 3,
    PetAlarmMode = 4,
    PetSafeZones = 5,
    PetAdventures = 6,
    UserAchievements = 7,
    UserSubscriptions = 8,
    UserSharing = 9,
    BeaconBattery = 10,
    FlashlightBattery = 11,
    System = 65535,
}

export class Invite implements IInvite {
    id?: string;
    level?: PetShareLevel;
    pet?: PetPartial;
    referrer?: ProfilePartial;

    constructor(data?: IInvite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.level = _data["level"];
            this.pet = _data["pet"] ? PetPartial.fromJS(_data["pet"]) : <any>undefined;
            this.referrer = _data["referrer"] ? ProfilePartial.fromJS(_data["referrer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Invite {
        data = typeof data === 'object' ? data : {};
        let result = new Invite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["level"] = this.level;
        data["pet"] = this.pet ? this.pet.toJSON() : <any>undefined;
        data["referrer"] = this.referrer ? this.referrer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInvite {
    id?: string;
    level?: PetShareLevel;
    pet?: PetPartial;
    referrer?: ProfilePartial;
}

/** 1 = Owner 2 = Family 3 = Friend 4 = Walker */
export enum PetShareLevel {
    Owner = 1,
    Family = 2,
    Friend = 3,
    Walker = 4,
}

export class PetPartial implements IPetPartial {
    id?: string;
    alias?: string;
    avatar?: string | undefined;

    constructor(data?: IPetPartial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.alias = _data["alias"];
            this.avatar = _data["avatar"];
        }
    }

    static fromJS(data: any): PetPartial {
        data = typeof data === 'object' ? data : {};
        let result = new PetPartial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alias"] = this.alias;
        data["avatar"] = this.avatar;
        return data;
    }
}

export interface IPetPartial {
    id?: string;
    alias?: string;
    avatar?: string | undefined;
}

export class Pet extends PetPartial implements IPet {
    sex?: Sex;
    birth_date?: moment.Moment;
    level?: PetShareLevel;
    breed?: Breed;
    owner?: ProfilePartial;
    weight?: number;
    height?: number;
    goal?: number | undefined;
    collar_id?: string | undefined;
    timeline?: PetTimeline;
    flashlight?: FlashlightSettings;
    shares?: Share[];

    constructor(data?: IPet) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sex = _data["sex"];
            this.birth_date = _data["birth_date"] ? moment(_data["birth_date"].toString()) : <any>undefined;
            this.level = _data["level"];
            this.breed = _data["breed"] ? Breed.fromJS(_data["breed"]) : <any>undefined;
            this.owner = _data["owner"] ? ProfilePartial.fromJS(_data["owner"]) : <any>undefined;
            this.weight = _data["weight"];
            this.height = _data["height"];
            this.goal = _data["goal"];
            this.collar_id = _data["collar_id"];
            this.timeline = _data["timeline"] ? PetTimeline.fromJS(_data["timeline"]) : <any>undefined;
            this.flashlight = _data["flashlight"] ? FlashlightSettings.fromJS(_data["flashlight"]) : <any>undefined;
            if (Array.isArray(_data["shares"])) {
                this.shares = [] as any;
                for (let item of _data["shares"])
                    this.shares!.push(Share.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Pet {
        data = typeof data === 'object' ? data : {};
        let result = new Pet();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sex"] = this.sex;
        data["birth_date"] = this.birth_date ? this.birth_date.format('YYYY-MM-DD') : <any>undefined;
        data["level"] = this.level;
        data["breed"] = this.breed ? this.breed.toJSON() : <any>undefined;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        data["weight"] = this.weight;
        data["height"] = this.height;
        data["goal"] = this.goal;
        data["collar_id"] = this.collar_id;
        data["timeline"] = this.timeline ? this.timeline.toJSON() : <any>undefined;
        data["flashlight"] = this.flashlight ? this.flashlight.toJSON() : <any>undefined;
        if (Array.isArray(this.shares)) {
            data["shares"] = [];
            for (let item of this.shares)
                data["shares"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPet extends IPetPartial {
    sex?: Sex;
    birth_date?: moment.Moment;
    level?: PetShareLevel;
    breed?: Breed;
    owner?: ProfilePartial;
    weight?: number;
    height?: number;
    goal?: number | undefined;
    collar_id?: string | undefined;
    timeline?: PetTimeline;
    flashlight?: FlashlightSettings;
    shares?: Share[];
}

export class Breed implements IBreed {
    id?: string;
    name?: string;

    constructor(data?: IBreed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Breed {
        data = typeof data === 'object' ? data : {};
        let result = new Breed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IBreed {
    id?: string;
    name?: string;
}

export class PetTimeline implements IPetTimeline {
    on_walk?: boolean;
    total_walks?: number;
    last_walk_id?: string | undefined;
    last_rest_id?: string | undefined;
    changed_at?: moment.Moment | undefined;

    constructor(data?: IPetTimeline) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.on_walk = _data["on_walk"];
            this.total_walks = _data["total_walks"];
            this.last_walk_id = _data["last_walk_id"];
            this.last_rest_id = _data["last_rest_id"];
            this.changed_at = _data["changed_at"] ? moment(_data["changed_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PetTimeline {
        data = typeof data === 'object' ? data : {};
        let result = new PetTimeline();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["on_walk"] = this.on_walk;
        data["total_walks"] = this.total_walks;
        data["last_walk_id"] = this.last_walk_id;
        data["last_rest_id"] = this.last_rest_id;
        data["changed_at"] = this.changed_at ? this.changed_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPetTimeline {
    on_walk?: boolean;
    total_walks?: number;
    last_walk_id?: string | undefined;
    last_rest_id?: string | undefined;
    changed_at?: moment.Moment | undefined;
}

export class FlashlightSettings implements IFlashlightSettings {
    revision?: number;
    animation?: number;
    lost_animation?: number;
    speed?: number;
    brightness?: number;
    custom_color?: string;
    creeping_line?: string;
    use_morse?: boolean;
    show_ble_state?: boolean;

    constructor(data?: IFlashlightSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.revision = _data["revision"];
            this.animation = _data["animation"];
            this.lost_animation = _data["lost_animation"];
            this.speed = _data["speed"];
            this.brightness = _data["brightness"];
            this.custom_color = _data["custom_color"];
            this.creeping_line = _data["creeping_line"];
            this.use_morse = _data["use_morse"];
            this.show_ble_state = _data["show_ble_state"];
        }
    }

    static fromJS(data: any): FlashlightSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FlashlightSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["revision"] = this.revision;
        data["animation"] = this.animation;
        data["lost_animation"] = this.lost_animation;
        data["speed"] = this.speed;
        data["brightness"] = this.brightness;
        data["custom_color"] = this.custom_color;
        data["creeping_line"] = this.creeping_line;
        data["use_morse"] = this.use_morse;
        data["show_ble_state"] = this.show_ble_state;
        return data;
    }
}

export interface IFlashlightSettings {
    revision?: number;
    animation?: number;
    lost_animation?: number;
    speed?: number;
    brightness?: number;
    custom_color?: string;
    creeping_line?: string;
    use_morse?: boolean;
    show_ble_state?: boolean;
}

export class Share implements IShare {
    id?: string;
    email?: string;
    first_name?: string | undefined;
    last_name?: string | undefined;
    full_name?: string | undefined;
    avatar?: string | undefined;
    level?: PetShareLevel;
    accepted?: boolean;

    constructor(data?: IShare) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.first_name = _data["first_name"];
            this.last_name = _data["last_name"];
            this.full_name = _data["full_name"];
            this.avatar = _data["avatar"];
            this.level = _data["level"];
            this.accepted = _data["accepted"];
        }
    }

    static fromJS(data: any): Share {
        data = typeof data === 'object' ? data : {};
        let result = new Share();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["first_name"] = this.first_name;
        data["last_name"] = this.last_name;
        data["full_name"] = this.full_name;
        data["avatar"] = this.avatar;
        data["level"] = this.level;
        data["accepted"] = this.accepted;
        return data;
    }
}

export interface IShare {
    id?: string;
    email?: string;
    first_name?: string | undefined;
    last_name?: string | undefined;
    full_name?: string | undefined;
    avatar?: string | undefined;
    level?: PetShareLevel;
    accepted?: boolean;
}

export class Collar implements ICollar {
    id?: string;
    serial_number?: string;
    mac_address?: string;
    firmware?: string;
    sim_status?: SimStatus;
    mode?: DeviceMode;
    user_mode?: DeviceUserMode;
    off_leash?: boolean;
    always_online?: boolean;
    gps_on_forever?: boolean;
    data_source?: DataSource | undefined;
    flashlight?: FlashlightStatus;
    errors?: DeviceError;
    empty_space?: number | undefined;
    empty_space_critical?: boolean;
    occupied_space?: number | undefined;
    last_active?: moment.Moment | undefined;
    battery?: Battery | undefined;
    subscription?: SubscriptionStatus;
    temp?: number | undefined;
    gps?: GPSMode;
    gsm_profile?: GsmProfile;
    lower_temp_alert?: number;
    upper_temp_alert?: number;
    pet_id?: string;
    timezone?: string | undefined;
    location?: GeoPoint | undefined;
    address?: string | undefined;
    activity?: Activity;
    online?: boolean;

    constructor(data?: ICollar) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serial_number = _data["serial_number"];
            this.mac_address = _data["mac_address"];
            this.firmware = _data["firmware"];
            this.sim_status = _data["sim_status"];
            this.mode = _data["mode"];
            this.user_mode = _data["user_mode"];
            this.off_leash = _data["off_leash"];
            this.always_online = _data["always_online"];
            this.gps_on_forever = _data["gps_on_forever"];
            this.data_source = _data["data_source"];
            this.flashlight = _data["flashlight"];
            this.errors = _data["errors"];
            this.empty_space = _data["empty_space"];
            this.empty_space_critical = _data["empty_space_critical"];
            this.occupied_space = _data["occupied_space"];
            this.last_active = _data["last_active"] ? moment(_data["last_active"].toString()) : <any>undefined;
            this.battery = _data["battery"] ? Battery.fromJS(_data["battery"]) : <any>undefined;
            this.subscription = _data["subscription"];
            this.temp = _data["temp"];
            this.gps = _data["gps"];
            this.gsm_profile = _data["gsm_profile"];
            this.lower_temp_alert = _data["lower_temp_alert"];
            this.upper_temp_alert = _data["upper_temp_alert"];
            this.pet_id = _data["pet_id"];
            this.timezone = _data["timezone"];
            this.location = _data["location"] ? GeoPoint.fromJS(_data["location"]) : <any>undefined;
            this.address = _data["address"];
            this.activity = _data["activity"] ? Activity.fromJS(_data["activity"]) : <any>undefined;
            this.online = _data["online"];
        }
    }

    static fromJS(data: any): Collar {
        data = typeof data === 'object' ? data : {};
        let result = new Collar();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serial_number"] = this.serial_number;
        data["mac_address"] = this.mac_address;
        data["firmware"] = this.firmware;
        data["sim_status"] = this.sim_status;
        data["mode"] = this.mode;
        data["user_mode"] = this.user_mode;
        data["off_leash"] = this.off_leash;
        data["always_online"] = this.always_online;
        data["gps_on_forever"] = this.gps_on_forever;
        data["data_source"] = this.data_source;
        data["flashlight"] = this.flashlight;
        data["errors"] = this.errors;
        data["empty_space"] = this.empty_space;
        data["empty_space_critical"] = this.empty_space_critical;
        data["occupied_space"] = this.occupied_space;
        data["last_active"] = this.last_active ? this.last_active.toISOString() : <any>undefined;
        data["battery"] = this.battery ? this.battery.toJSON() : <any>undefined;
        data["subscription"] = this.subscription;
        data["temp"] = this.temp;
        data["gps"] = this.gps;
        data["gsm_profile"] = this.gsm_profile;
        data["lower_temp_alert"] = this.lower_temp_alert;
        data["upper_temp_alert"] = this.upper_temp_alert;
        data["pet_id"] = this.pet_id;
        data["timezone"] = this.timezone;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["address"] = this.address;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["online"] = this.online;
        return data;
    }
}

export interface ICollar {
    id?: string;
    serial_number?: string;
    mac_address?: string;
    firmware?: string;
    sim_status?: SimStatus;
    mode?: DeviceMode;
    user_mode?: DeviceUserMode;
    off_leash?: boolean;
    always_online?: boolean;
    gps_on_forever?: boolean;
    data_source?: DataSource | undefined;
    flashlight?: FlashlightStatus;
    errors?: DeviceError;
    empty_space?: number | undefined;
    empty_space_critical?: boolean;
    occupied_space?: number | undefined;
    last_active?: moment.Moment | undefined;
    battery?: Battery | undefined;
    subscription?: SubscriptionStatus;
    temp?: number | undefined;
    gps?: GPSMode;
    gsm_profile?: GsmProfile;
    lower_temp_alert?: number;
    upper_temp_alert?: number;
    pet_id?: string;
    timezone?: string | undefined;
    location?: GeoPoint | undefined;
    address?: string | undefined;
    activity?: Activity;
    online?: boolean;
}

/** Статус SIM-карты 0 = Inactive 1 = Active 2 = Pending */
export enum SimStatus {
    Inactive = 0,
    Active = 1,
    Pending = 2,
}

/** 0 = NotSet 1 = Sleep 2 = Safe 3 = Walk 4 = Alarm 5 = Lost 6 = Charging 7 = FwUpdate 8 = Begin 9 = Fsafe 10 = Fwalk 11 = Off 12 = NotSetDog 13 = NotActivated 14 = LowEnergy 15 = Ble 16 = FirstWu 17 = EnergySaving 18 = OffLeash 99 = Idle 100 = NotWalking */
export enum DeviceMode {
    NotSet = 0,
    Sleep = 1,
    Safe = 2,
    Walk = 3,
    Alarm = 4,
    Lost = 5,
    Charging = 6,
    FwUpdate = 7,
    Begin = 8,
    Fsafe = 9,
    Fwalk = 10,
    Off = 11,
    NotSetDog = 12,
    NotActivated = 13,
    LowEnergy = 14,
    Ble = 15,
    FirstWu = 16,
    EnergySaving = 17,
    OffLeash = 18,
    Idle = 99,
    NotWalking = 100,
}

/** 0 = Interactive 1 = Lost 2 = EnergySaving 3 = LowEnergy */
export enum DeviceUserMode {
    Interactive = 0,
    Lost = 1,
    EnergySaving = 2,
    LowEnergy = 3,
}

/** 0 = G 1 = B 2 = W */
export enum DataSource {
    G = 0,
    B = 1,
    W = 2,
}

/** 0 = Off 1 = On 2 = Auto */
export enum FlashlightStatus {
    Off = 0,
    On = 1,
    Auto = 2,
}

/** 0 = None 1 = FlashMemoryError 2 = BadBatteryConnection 4 = GpsJamming 8 = GsmJamming 16 = IMUError 32 = Reserved2 64 = Reserved1 128 = Reserved0 */
export enum DeviceError {
    None = 0,
    FlashMemoryError = 1,
    BadBatteryConnection = 2,
    GpsJamming = 4,
    GsmJamming = 8,
    IMUError = 16,
    Reserved2 = 32,
    Reserved1 = 64,
    Reserved0 = 128,
}

export class Battery implements IBattery {
    serial_number?: string | undefined;
    charge?: number;
    cycles?: number;
    capacity?: number;
    max_capacity?: number;
    attach_charge?: number;
    attach_time?: moment.Moment;
    status?: BatteryStatus;
    life_alarm?: number;
    life_safe?: number;
    life_walk?: number;
    life_lost?: number;
    life_off_leash?: number;
    life_energy_saving?: number;

    constructor(data?: IBattery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serial_number = _data["serial_number"];
            this.charge = _data["charge"];
            this.cycles = _data["cycles"];
            this.capacity = _data["capacity"];
            this.max_capacity = _data["max_capacity"];
            this.attach_charge = _data["attach_charge"];
            this.attach_time = _data["attach_time"] ? moment(_data["attach_time"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.life_alarm = _data["life_alarm"];
            this.life_safe = _data["life_safe"];
            this.life_walk = _data["life_walk"];
            this.life_lost = _data["life_lost"];
            this.life_off_leash = _data["life_off_leash"];
            this.life_energy_saving = _data["life_energy_saving"];
        }
    }

    static fromJS(data: any): Battery {
        data = typeof data === 'object' ? data : {};
        let result = new Battery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial_number"] = this.serial_number;
        data["charge"] = this.charge;
        data["cycles"] = this.cycles;
        data["capacity"] = this.capacity;
        data["max_capacity"] = this.max_capacity;
        data["attach_charge"] = this.attach_charge;
        data["attach_time"] = this.attach_time ? this.attach_time.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["life_alarm"] = this.life_alarm;
        data["life_safe"] = this.life_safe;
        data["life_walk"] = this.life_walk;
        data["life_lost"] = this.life_lost;
        data["life_off_leash"] = this.life_off_leash;
        data["life_energy_saving"] = this.life_energy_saving;
        return data;
    }
}

export interface IBattery {
    serial_number?: string | undefined;
    charge?: number;
    cycles?: number;
    capacity?: number;
    max_capacity?: number;
    attach_charge?: number;
    attach_time?: moment.Moment;
    status?: BatteryStatus;
    life_alarm?: number;
    life_safe?: number;
    life_walk?: number;
    life_lost?: number;
    life_off_leash?: number;
    life_energy_saving?: number;
}

/** Износ аккумулятора. 0 = Unknown 1 = Good 2 = Poor 3 = Critical */
export enum BatteryStatus {
    Unknown = 0,
    Good = 1,
    Poor = 2,
    Critical = 3,
}

/** Subscription status 0 = Undefined 2 = Active 4 = Cancelled */
export enum SubscriptionStatus {
    Undefined = 0,
    Active = 2,
    Cancelled = 4,
}

/** 0 = GpsOnly 1 = VsGLONASS 2 = VsBEIDOU 3 = VsGALILEO 4 = VsGALILEOAndGLONASS */
export enum GPSMode {
    GpsOnly = 0,
    VsGLONASS = 1,
    VsBEIDOU = 2,
    VsGALILEO = 3,
    VsGALILEOAndGLONASS = 4,
}

/** 0 = Common 1 = AtAndT 2 = Verizon 3 = Au */
export enum GsmProfile {
    Common = 0,
    AtAndT = 1,
    Verizon = 2,
    Au = 3,
}

export class GeoPoint implements IGeoPoint {
    lng?: number;
    lat?: number;
    acc?: number;
    src?: CoordinateFixType;
    timestamp?: moment.Moment;

    constructor(data?: IGeoPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lng = _data["lng"];
            this.lat = _data["lat"];
            this.acc = _data["acc"];
            this.src = _data["src"];
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GeoPoint {
        data = typeof data === 'object' ? data : {};
        let result = new GeoPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lng"] = this.lng;
        data["lat"] = this.lat;
        data["acc"] = this.acc;
        data["src"] = this.src;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGeoPoint {
    lng?: number;
    lat?: number;
    acc?: number;
    src?: CoordinateFixType;
    timestamp?: moment.Moment;
}

/** Тип фиксации координат 0 = None 1 = LowAccuracy 2 = Gps2D 3 = Gps3D 4 = Phone 5 = Gsm 6 = WiFi */
export enum CoordinateFixType {
    None = 0,
    LowAccuracy = 1,
    Gps2D = 2,
    Gps3D = 3,
    Phone = 4,
    Gsm = 5,
    WiFi = 6,
}

export class Activity implements IActivity {
    mode?: DeviceActivity | undefined;
    steps?: number;
    distance?: number;
    duration?: moment.Duration;
    rest?: moment.Duration;
    calories?: number;

    constructor(data?: IActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mode = _data["mode"];
            this.steps = _data["steps"];
            this.distance = _data["distance"];
            this.duration = _data["duration"] ? moment.duration(_data["duration"].toString()) : <any>undefined;
            this.rest = _data["rest"] ? moment.duration(_data["rest"].toString()) : <any>undefined;
            this.calories = _data["calories"];
        }
    }

    static fromJS(data: any): Activity {
        data = typeof data === 'object' ? data : {};
        let result = new Activity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mode"] = this.mode;
        data["steps"] = this.steps;
        data["distance"] = this.distance;
        data["duration"] = this.duration ? this.duration.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["rest"] = this.rest ? this.rest.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["calories"] = this.calories;
        return data;
    }
}

export interface IActivity {
    mode?: DeviceActivity | undefined;
    steps?: number;
    distance?: number;
    duration?: moment.Duration;
    rest?: moment.Duration;
    calories?: number;
}

/** Тип активности питомца            0 = Sleep 1 = Step 2 = Run 6 = Trot 15 = GoToSleep */
export enum DeviceActivity {
    Sleep = 0,
    Step = 1,
    Run = 2,
    Trot = 6,
    GoToSleep = 15,
}

export class Flashlight implements IFlashlight {
    mac_address?: string | undefined;
    serial_number?: string;
    firmware?: string;
    update_available?: boolean;
    pet_id?: string;
    collar_id?: string;
    location?: Location | undefined;
    charge?: number | undefined;
    settings_revision?: number;
    unique_color?: UniqueColor;
    holder_color?: DeviceColor;
    updated_at?: moment.Moment;

    constructor(data?: IFlashlight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mac_address = _data["mac_address"];
            this.serial_number = _data["serial_number"];
            this.firmware = _data["firmware"];
            this.update_available = _data["update_available"];
            this.pet_id = _data["pet_id"];
            this.collar_id = _data["collar_id"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.charge = _data["charge"];
            this.settings_revision = _data["settings_revision"];
            this.unique_color = _data["unique_color"];
            this.holder_color = _data["holder_color"];
            this.updated_at = _data["updated_at"] ? moment(_data["updated_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Flashlight {
        data = typeof data === 'object' ? data : {};
        let result = new Flashlight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mac_address"] = this.mac_address;
        data["serial_number"] = this.serial_number;
        data["firmware"] = this.firmware;
        data["update_available"] = this.update_available;
        data["pet_id"] = this.pet_id;
        data["collar_id"] = this.collar_id;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["charge"] = this.charge;
        data["settings_revision"] = this.settings_revision;
        data["unique_color"] = this.unique_color;
        data["holder_color"] = this.holder_color;
        data["updated_at"] = this.updated_at ? this.updated_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFlashlight {
    mac_address?: string | undefined;
    serial_number?: string;
    firmware?: string;
    update_available?: boolean;
    pet_id?: string;
    collar_id?: string;
    location?: Location | undefined;
    charge?: number | undefined;
    settings_revision?: number;
    unique_color?: UniqueColor;
    holder_color?: DeviceColor;
    updated_at?: moment.Moment;
}

export class Location implements ILocation {
    lng?: number;
    lat?: number;
    timestamp?: moment.Moment;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lng = _data["lng"];
            this.lat = _data["lat"];
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lng"] = this.lng;
        data["lat"] = this.lat;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILocation {
    lng?: number;
    lat?: number;
    timestamp?: moment.Moment;
}

/** 0 = Red 1 = Orange 2 = Yellow 3 = Green 4 = Blue 5 = Purple 6 = White 7 = Brown */
export enum UniqueColor {
    Red = 0,
    Orange = 1,
    Yellow = 2,
    Green = 3,
    Blue = 4,
    Purple = 5,
    White = 6,
    Brown = 7,
}

/** 0 = Black 1 = Red 2 = Green */
export enum DeviceColor {
    Black = 0,
    Red = 1,
    Green = 2,
}

export class SafeZone implements ISafeZone {
    id?: string;
    title?: string;
    area?: number[][];
    address?: string;
    preview?: string;
    owner?: ProfilePartial;
    created_at?: moment.Moment;
    access_points?: AccessPoint[];
    ble_beacons?: Beacon[];
    pets?: PetPartial[];

    constructor(data?: ISafeZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            if (Array.isArray(_data["area"])) {
                this.area = [] as any;
                for (let item of _data["area"])
                    this.area!.push(item);
            }
            this.address = _data["address"];
            this.preview = _data["preview"];
            this.owner = _data["owner"] ? ProfilePartial.fromJS(_data["owner"]) : <any>undefined;
            this.created_at = _data["created_at"] ? moment(_data["created_at"].toString()) : <any>undefined;
            if (Array.isArray(_data["access_points"])) {
                this.access_points = [] as any;
                for (let item of _data["access_points"])
                    this.access_points!.push(AccessPoint.fromJS(item));
            }
            if (Array.isArray(_data["ble_beacons"])) {
                this.ble_beacons = [] as any;
                for (let item of _data["ble_beacons"])
                    this.ble_beacons!.push(Beacon.fromJS(item));
            }
            if (Array.isArray(_data["pets"])) {
                this.pets = [] as any;
                for (let item of _data["pets"])
                    this.pets!.push(PetPartial.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SafeZone {
        data = typeof data === 'object' ? data : {};
        let result = new SafeZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        if (Array.isArray(this.area)) {
            data["area"] = [];
            for (let item of this.area)
                data["area"].push(item);
        }
        data["address"] = this.address;
        data["preview"] = this.preview;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        if (Array.isArray(this.access_points)) {
            data["access_points"] = [];
            for (let item of this.access_points)
                data["access_points"].push(item.toJSON());
        }
        if (Array.isArray(this.ble_beacons)) {
            data["ble_beacons"] = [];
            for (let item of this.ble_beacons)
                data["ble_beacons"].push(item.toJSON());
        }
        if (Array.isArray(this.pets)) {
            data["pets"] = [];
            for (let item of this.pets)
                data["pets"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISafeZone {
    id?: string;
    title?: string;
    area?: number[][];
    address?: string;
    preview?: string;
    owner?: ProfilePartial;
    created_at?: moment.Moment;
    access_points?: AccessPoint[];
    ble_beacons?: Beacon[];
    pets?: PetPartial[];
}

export class AccessPoint implements IAccessPoint {
    ssid?: string;
    connection_status?: AccessPointConnectionStatus;

    constructor(data?: IAccessPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ssid = _data["ssid"];
            this.connection_status = _data["connection_status"];
        }
    }

    static fromJS(data: any): AccessPoint {
        data = typeof data === 'object' ? data : {};
        let result = new AccessPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ssid"] = this.ssid;
        data["connection_status"] = this.connection_status;
        return data;
    }
}

export interface IAccessPoint {
    ssid?: string;
    connection_status?: AccessPointConnectionStatus;
}

/** 0 = NotConnectedYet 21 = Successful 22 = GeneralError 23 = ServerError 24 = TimeoutError 25 = NotFoundError */
export enum AccessPointConnectionStatus {
    NotConnectedYet = 0,
    Successful = 21,
    GeneralError = 22,
    ServerError = 23,
    TimeoutError = 24,
    NotFoundError = 25,
}

export class Beacon implements IBeacon {
    name?: string;
    serial_number?: string | undefined;
    mac_address?: string | undefined;
    restricted_zone?: boolean;
    battery_charge?: number | undefined;
    tx_power?: SByte | undefined;
    updated_at?: moment.Moment;

    constructor(data?: IBeacon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.serial_number = _data["serial_number"];
            this.mac_address = _data["mac_address"];
            this.restricted_zone = _data["restricted_zone"];
            this.battery_charge = _data["battery_charge"];
            this.tx_power = _data["tx_power"] ? SByte.fromJS(_data["tx_power"]) : <any>undefined;
            this.updated_at = _data["updated_at"] ? moment(_data["updated_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Beacon {
        data = typeof data === 'object' ? data : {};
        let result = new Beacon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["serial_number"] = this.serial_number;
        data["mac_address"] = this.mac_address;
        data["restricted_zone"] = this.restricted_zone;
        data["battery_charge"] = this.battery_charge;
        data["tx_power"] = this.tx_power ? this.tx_power.toJSON() : <any>undefined;
        data["updated_at"] = this.updated_at ? this.updated_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBeacon {
    name?: string;
    serial_number?: string | undefined;
    mac_address?: string | undefined;
    restricted_zone?: boolean;
    battery_charge?: number | undefined;
    tx_power?: SByte | undefined;
    updated_at?: moment.Moment;
}

export class SByte implements ISByte {

    constructor(data?: ISByte) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SByte {
        data = typeof data === 'object' ? data : {};
        let result = new SByte();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISByte {
}

export class TrailPoint implements ITrailPoint {
    location?: Point;
    mode?: DeviceMode;

    constructor(data?: ITrailPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"] ? Point.fromJS(_data["location"]) : <any>undefined;
            this.mode = _data["mode"];
        }
    }

    static fromJS(data: any): TrailPoint {
        data = typeof data === 'object' ? data : {};
        let result = new TrailPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["mode"] = this.mode;
        return data;
    }
}

export interface ITrailPoint {
    location?: Point;
    mode?: DeviceMode;
}

export class Point implements IPoint {
    lng?: number;
    lat?: number;
    alt?: number | undefined;

    [key: string]: any;

    constructor(data?: IPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.lng = _data["lng"];
            this.lat = _data["lat"];
            this.alt = _data["alt"];
        }
    }

    static fromJS(data: any): Point {
        data = typeof data === 'object' ? data : {};
        let result = new Point();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["lng"] = this.lng;
        data["lat"] = this.lat;
        data["alt"] = this.alt;
        return data;
    }
}

export interface IPoint {
    lng?: number;
    lat?: number;
    alt?: number | undefined;

    [key: string]: any;
}

export class GeoPlaceModel implements IGeoPlaceModel {
    id?: string | undefined;
    description?: string | undefined;
    address?: string | undefined;
    region?: string | undefined;
    location?: Point | undefined;
    distance?: number;

    constructor(data?: IGeoPlaceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.address = _data["address"];
            this.region = _data["region"];
            this.location = _data["location"] ? Point.fromJS(_data["location"]) : <any>undefined;
            this.distance = _data["distance"];
        }
    }

    static fromJS(data: any): GeoPlaceModel {
        data = typeof data === 'object' ? data : {};
        let result = new GeoPlaceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["address"] = this.address;
        data["region"] = this.region;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["distance"] = this.distance;
        return data;
    }
}

export interface IGeoPlaceModel {
    id?: string | undefined;
    description?: string | undefined;
    address?: string | undefined;
    region?: string | undefined;
    location?: Point | undefined;
    distance?: number;
}

export class GeoPointModel implements IGeoPointModel {
    lat?: number;
    lon?: number;

    constructor(data?: IGeoPointModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lat = _data["lat"];
            this.lon = _data["lon"];
        }
    }

    static fromJS(data: any): GeoPointModel {
        data = typeof data === 'object' ? data : {};
        let result = new GeoPointModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        return data;
    }
}

export interface IGeoPointModel {
    lat?: number;
    lon?: number;
}

export class TimelineTree implements ITimelineTree {
    days?: number;
    walk_amount?: number;
    rest_amount?: number;
    walk_steps?: number;
    walk_distance?: number;
    rest_steps?: number;
    rest_distance?: number;
    walk_avg_steps?: number;
    walk_avg_distance?: number;
    rest_avg_steps?: number;
    rest_avg_distance?: number;
    years?: TimelineTreeYear[] | undefined;

    constructor(data?: ITimelineTree) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.days = _data["days"];
            this.walk_amount = _data["walk_amount"];
            this.rest_amount = _data["rest_amount"];
            this.walk_steps = _data["walk_steps"];
            this.walk_distance = _data["walk_distance"];
            this.rest_steps = _data["rest_steps"];
            this.rest_distance = _data["rest_distance"];
            this.walk_avg_steps = _data["walk_avg_steps"];
            this.walk_avg_distance = _data["walk_avg_distance"];
            this.rest_avg_steps = _data["rest_avg_steps"];
            this.rest_avg_distance = _data["rest_avg_distance"];
            if (Array.isArray(_data["years"])) {
                this.years = [] as any;
                for (let item of _data["years"])
                    this.years!.push(TimelineTreeYear.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimelineTree {
        data = typeof data === 'object' ? data : {};
        let result = new TimelineTree();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["days"] = this.days;
        data["walk_amount"] = this.walk_amount;
        data["rest_amount"] = this.rest_amount;
        data["walk_steps"] = this.walk_steps;
        data["walk_distance"] = this.walk_distance;
        data["rest_steps"] = this.rest_steps;
        data["rest_distance"] = this.rest_distance;
        data["walk_avg_steps"] = this.walk_avg_steps;
        data["walk_avg_distance"] = this.walk_avg_distance;
        data["rest_avg_steps"] = this.rest_avg_steps;
        data["rest_avg_distance"] = this.rest_avg_distance;
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITimelineTree {
    days?: number;
    walk_amount?: number;
    rest_amount?: number;
    walk_steps?: number;
    walk_distance?: number;
    rest_steps?: number;
    rest_distance?: number;
    walk_avg_steps?: number;
    walk_avg_distance?: number;
    rest_avg_steps?: number;
    rest_avg_distance?: number;
    years?: TimelineTreeYear[] | undefined;
}

export class TimelineTreeYear implements ITimelineTreeYear {
    year?: number;
    walk_steps?: number;
    walk_distance?: number;
    rest_steps?: number;
    rest_distance?: number;
    walk_amount?: number;
    rest_amount?: number;
    months?: TimelineTreeMonth[] | undefined;

    constructor(data?: ITimelineTreeYear) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.walk_steps = _data["walk_steps"];
            this.walk_distance = _data["walk_distance"];
            this.rest_steps = _data["rest_steps"];
            this.rest_distance = _data["rest_distance"];
            this.walk_amount = _data["walk_amount"];
            this.rest_amount = _data["rest_amount"];
            if (Array.isArray(_data["months"])) {
                this.months = [] as any;
                for (let item of _data["months"])
                    this.months!.push(TimelineTreeMonth.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimelineTreeYear {
        data = typeof data === 'object' ? data : {};
        let result = new TimelineTreeYear();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["walk_steps"] = this.walk_steps;
        data["walk_distance"] = this.walk_distance;
        data["rest_steps"] = this.rest_steps;
        data["rest_distance"] = this.rest_distance;
        data["walk_amount"] = this.walk_amount;
        data["rest_amount"] = this.rest_amount;
        if (Array.isArray(this.months)) {
            data["months"] = [];
            for (let item of this.months)
                data["months"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITimelineTreeYear {
    year?: number;
    walk_steps?: number;
    walk_distance?: number;
    rest_steps?: number;
    rest_distance?: number;
    walk_amount?: number;
    rest_amount?: number;
    months?: TimelineTreeMonth[] | undefined;
}

export class TimelineTreeMonth implements ITimelineTreeMonth {
    month?: number;
    walk_steps?: number;
    walk_distance?: number;
    rest_steps?: number;
    rest_distance?: number;
    walk_amount?: number;
    rest_amount?: number;
    days?: TimelineTreeDay[] | undefined;

    constructor(data?: ITimelineTreeMonth) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.walk_steps = _data["walk_steps"];
            this.walk_distance = _data["walk_distance"];
            this.rest_steps = _data["rest_steps"];
            this.rest_distance = _data["rest_distance"];
            this.walk_amount = _data["walk_amount"];
            this.rest_amount = _data["rest_amount"];
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(TimelineTreeDay.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimelineTreeMonth {
        data = typeof data === 'object' ? data : {};
        let result = new TimelineTreeMonth();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["walk_steps"] = this.walk_steps;
        data["walk_distance"] = this.walk_distance;
        data["rest_steps"] = this.rest_steps;
        data["rest_distance"] = this.rest_distance;
        data["walk_amount"] = this.walk_amount;
        data["rest_amount"] = this.rest_amount;
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITimelineTreeMonth {
    month?: number;
    walk_steps?: number;
    walk_distance?: number;
    rest_steps?: number;
    rest_distance?: number;
    walk_amount?: number;
    rest_amount?: number;
    days?: TimelineTreeDay[] | undefined;
}

export class TimelineTreeDay implements ITimelineTreeDay {
    day?: number;
    walk_steps?: number;
    walk_distance?: number;
    rest_steps?: number;
    rest_distance?: number;
    walk_amount?: number;
    rest_amount?: number;

    constructor(data?: ITimelineTreeDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            this.walk_steps = _data["walk_steps"];
            this.walk_distance = _data["walk_distance"];
            this.rest_steps = _data["rest_steps"];
            this.rest_distance = _data["rest_distance"];
            this.walk_amount = _data["walk_amount"];
            this.rest_amount = _data["rest_amount"];
        }
    }

    static fromJS(data: any): TimelineTreeDay {
        data = typeof data === 'object' ? data : {};
        let result = new TimelineTreeDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["walk_steps"] = this.walk_steps;
        data["walk_distance"] = this.walk_distance;
        data["rest_steps"] = this.rest_steps;
        data["rest_distance"] = this.rest_distance;
        data["walk_amount"] = this.walk_amount;
        data["rest_amount"] = this.rest_amount;
        return data;
    }
}

export interface ITimelineTreeDay {
    day?: number;
    walk_steps?: number;
    walk_distance?: number;
    rest_steps?: number;
    rest_distance?: number;
    walk_amount?: number;
    rest_amount?: number;
}

export class ProblemDetails implements IProblemDetails {
    /** A URI reference [RFC3986] that identifies the
            problem type.  This specification encourages that, when
                dereferenced, it provide human-readable documentation for the
                problem type (e.g., using HTML [W3C.REC-html5-20141028]).  When
                this member is not present, its value is assumed to be
            "about:blank". */
    type?: string | undefined;
    /** A short, human-readable summary of the problem
            type.  It SHOULD NOT change from occurrence to occurrence of the
            problem, except for purposes of localization (e.g., using
            proactive content negotiation; see [RFC7231], Section 3.4). */
    title?: string | undefined;
    /** The HTTP status code([RFC7231], Section 6) generated by the origin server for this occurrence of the problem. */
    status?: number | undefined;
    /** A human-readable explanation specific to this occurrence of the problem. */
    detail?: string | undefined;
    /** A URI reference that identifies the specific occurrence of the problem.It may or may not yield further information if dereferenced. */
    instance?: string | undefined;
    /** List of validation errors. */
    errors?: ValidationError[] | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ValidationError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProblemDetails {
    /** A URI reference [RFC3986] that identifies the
            problem type.  This specification encourages that, when
                dereferenced, it provide human-readable documentation for the
                problem type (e.g., using HTML [W3C.REC-html5-20141028]).  When
                this member is not present, its value is assumed to be
            "about:blank". */
    type?: string | undefined;
    /** A short, human-readable summary of the problem
            type.  It SHOULD NOT change from occurrence to occurrence of the
            problem, except for purposes of localization (e.g., using
            proactive content negotiation; see [RFC7231], Section 3.4). */
    title?: string | undefined;
    /** The HTTP status code([RFC7231], Section 6) generated by the origin server for this occurrence of the problem. */
    status?: number | undefined;
    /** A human-readable explanation specific to this occurrence of the problem. */
    detail?: string | undefined;
    /** A URI reference that identifies the specific occurrence of the problem.It may or may not yield further information if dereferenced. */
    instance?: string | undefined;
    /** List of validation errors. */
    errors?: ValidationError[] | undefined;
}

export class ValidationError implements IValidationError {
    /** Field name. */
    key?: string | undefined;
    /** Description. */
    value?: string | undefined;

    constructor(data?: IValidationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ValidationError {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IValidationError {
    /** Field name. */
    key?: string | undefined;
    /** Description. */
    value?: string | undefined;
}

export class Timeline implements ITimeline {
    type?: string | undefined;
    id?: string;
    title?: string | undefined;
    started_at?: moment.Moment;
    ended_at?: moment.Moment | undefined;
    started_at_zone?: string | undefined;
    ended_at_zone?: string | undefined;
    distance?: number;
    preview?: string | undefined;
    calories?: number;
    steps?: number;
    run_time?: moment.Duration;
    rest_time?: moment.Duration;
    walkers?: CustomerPartial[] | undefined;
    achievements?: Achievement[] | undefined;
    duration?: moment.Duration;

    constructor(data?: ITimeline) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.started_at = _data["started_at"] ? moment(_data["started_at"].toString()) : <any>undefined;
            this.ended_at = _data["ended_at"] ? moment(_data["ended_at"].toString()) : <any>undefined;
            this.started_at_zone = _data["started_at_zone"];
            this.ended_at_zone = _data["ended_at_zone"];
            this.distance = _data["distance"];
            this.preview = _data["preview"];
            this.calories = _data["calories"];
            this.steps = _data["steps"];
            this.run_time = _data["run_time"] ? moment.duration(_data["run_time"].toString()) : <any>undefined;
            this.rest_time = _data["rest_time"] ? moment.duration(_data["rest_time"].toString()) : <any>undefined;
            if (Array.isArray(_data["walkers"])) {
                this.walkers = [] as any;
                for (let item of _data["walkers"])
                    this.walkers!.push(CustomerPartial.fromJS(item));
            }
            if (Array.isArray(_data["achievements"])) {
                this.achievements = [] as any;
                for (let item of _data["achievements"])
                    this.achievements!.push(Achievement.fromJS(item));
            }
            this.duration = _data["duration"] ? moment.duration(_data["duration"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Timeline {
        data = typeof data === 'object' ? data : {};
        let result = new Timeline();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        data["title"] = this.title;
        data["started_at"] = this.started_at ? this.started_at.toISOString() : <any>undefined;
        data["ended_at"] = this.ended_at ? this.ended_at.toISOString() : <any>undefined;
        data["started_at_zone"] = this.started_at_zone;
        data["ended_at_zone"] = this.ended_at_zone;
        data["distance"] = this.distance;
        data["preview"] = this.preview;
        data["calories"] = this.calories;
        data["steps"] = this.steps;
        data["run_time"] = this.run_time ? this.run_time.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["rest_time"] = this.rest_time ? this.rest_time.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        if (Array.isArray(this.walkers)) {
            data["walkers"] = [];
            for (let item of this.walkers)
                data["walkers"].push(item.toJSON());
        }
        if (Array.isArray(this.achievements)) {
            data["achievements"] = [];
            for (let item of this.achievements)
                data["achievements"].push(item.toJSON());
        }
        data["duration"] = this.duration ? this.duration.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        return data;
    }
}

export interface ITimeline {
    type?: string | undefined;
    id?: string;
    title?: string | undefined;
    started_at?: moment.Moment;
    ended_at?: moment.Moment | undefined;
    started_at_zone?: string | undefined;
    ended_at_zone?: string | undefined;
    distance?: number;
    preview?: string | undefined;
    calories?: number;
    steps?: number;
    run_time?: moment.Duration;
    rest_time?: moment.Duration;
    walkers?: CustomerPartial[] | undefined;
    achievements?: Achievement[] | undefined;
    duration?: moment.Duration;
}

export class CustomerPartial implements ICustomerPartial {
    id?: string;
    email?: string | undefined;
    first_name?: string | undefined;
    last_name?: string | undefined;
    full_name?: string | undefined;
    avatar?: string | undefined;

    constructor(data?: ICustomerPartial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.first_name = _data["first_name"];
            this.last_name = _data["last_name"];
            this.full_name = _data["full_name"];
            this.avatar = _data["avatar"];
        }
    }

    static fromJS(data: any): CustomerPartial {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerPartial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["first_name"] = this.first_name;
        data["last_name"] = this.last_name;
        data["full_name"] = this.full_name;
        data["avatar"] = this.avatar;
        return data;
    }
}

export interface ICustomerPartial {
    id?: string;
    email?: string | undefined;
    first_name?: string | undefined;
    last_name?: string | undefined;
    full_name?: string | undefined;
    avatar?: string | undefined;
}

export class Achievement implements IAchievement {
    id?: string | undefined;
    amount?: number;

    constructor(data?: IAchievement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): Achievement {
        data = typeof data === 'object' ? data : {};
        let result = new Achievement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IAchievement {
    id?: string | undefined;
    amount?: number;
}

export class Walk extends Timeline implements IWalk {
    parts?: WalkPart[] | undefined;
    weather?: Weather | undefined;
    note?: string | undefined;
    place?: string | undefined;
    prev_id?: string | undefined;

    constructor(data?: IWalk) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["parts"])) {
                this.parts = [] as any;
                for (let item of _data["parts"])
                    this.parts!.push(WalkPart.fromJS(item));
            }
            this.weather = _data["weather"] ? Weather.fromJS(_data["weather"]) : <any>undefined;
            this.note = _data["note"];
            this.place = _data["place"];
            this.prev_id = _data["prev_id"];
        }
    }

    static override fromJS(data: any): Walk {
        data = typeof data === 'object' ? data : {};
        let result = new Walk();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.parts)) {
            data["parts"] = [];
            for (let item of this.parts)
                data["parts"].push(item.toJSON());
        }
        data["weather"] = this.weather ? this.weather.toJSON() : <any>undefined;
        data["note"] = this.note;
        data["place"] = this.place;
        data["prev_id"] = this.prev_id;
        super.toJSON(data);
        return data;
    }
}

export interface IWalk extends ITimeline {
    parts?: WalkPart[] | undefined;
    weather?: Weather | undefined;
    note?: string | undefined;
    place?: string | undefined;
    prev_id?: string | undefined;
}

export class WalkPart implements IWalkPart {
    level?: SpeedLevel;
    points?: WalkPoint[] | undefined;

    constructor(data?: IWalkPart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"];
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(WalkPoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WalkPart {
        data = typeof data === 'object' ? data : {};
        let result = new WalkPart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWalkPart {
    level?: SpeedLevel;
    points?: WalkPoint[] | undefined;
}

/** 1 = OnFoot 2 = Car 4 = Plane 255 = Off */
export enum SpeedLevel {
    OnFoot = 1,
    Car = 2,
    Plane = 4,
    Off = 255,
}

export class WalkPoint implements IWalkPoint {
    timestamp?: moment.Moment;
    lng?: number;
    lat?: number;
    battery_charge?: number;

    constructor(data?: IWalkPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>undefined;
            this.lng = _data["lng"];
            this.lat = _data["lat"];
            this.battery_charge = _data["battery_charge"];
        }
    }

    static fromJS(data: any): WalkPoint {
        data = typeof data === 'object' ? data : {};
        let result = new WalkPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["lng"] = this.lng;
        data["lat"] = this.lat;
        data["battery_charge"] = this.battery_charge;
        return data;
    }
}

export interface IWalkPoint {
    timestamp?: moment.Moment;
    lng?: number;
    lat?: number;
    battery_charge?: number;
}

export class Weather implements IWeather {
    type?: number;
    temp?: number;
    wind_speed?: number;
    humidity?: number;
    icon?: string | undefined;

    constructor(data?: IWeather) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.temp = _data["temp"];
            this.wind_speed = _data["wind_speed"];
            this.humidity = _data["humidity"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): Weather {
        data = typeof data === 'object' ? data : {};
        let result = new Weather();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["temp"] = this.temp;
        data["wind_speed"] = this.wind_speed;
        data["humidity"] = this.humidity;
        data["icon"] = this.icon;
        return data;
    }
}

export interface IWeather {
    type?: number;
    temp?: number;
    wind_speed?: number;
    humidity?: number;
    icon?: string | undefined;
}

export class Rest extends Timeline implements IRest {
    polygon?: number[][] | undefined;
    history?: RestHistory[] | undefined;

    constructor(data?: IRest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["polygon"])) {
                this.polygon = [] as any;
                for (let item of _data["polygon"])
                    this.polygon!.push(item);
            }
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(RestHistory.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Rest {
        data = typeof data === 'object' ? data : {};
        let result = new Rest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.polygon)) {
            data["polygon"] = [];
            for (let item of this.polygon)
                data["polygon"].push(item);
        }
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IRest extends ITimeline {
    polygon?: number[][] | undefined;
    history?: RestHistory[] | undefined;
}

export class RestHistory implements IRestHistory {
    type?: SafeZoneType;
    name?: string | undefined;
    started_at?: moment.Moment;
    duration?: moment.Duration;
    steps?: number;
    distance?: number;
    calories?: number;
    run_time?: moment.Duration;
    rest_time?: moment.Duration;

    constructor(data?: IRestHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
            this.started_at = _data["started_at"] ? moment(_data["started_at"].toString()) : <any>undefined;
            this.duration = _data["duration"] ? moment.duration(_data["duration"].toString()) : <any>undefined;
            this.steps = _data["steps"];
            this.distance = _data["distance"];
            this.calories = _data["calories"];
            this.run_time = _data["run_time"] ? moment.duration(_data["run_time"].toString()) : <any>undefined;
            this.rest_time = _data["rest_time"] ? moment.duration(_data["rest_time"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RestHistory {
        data = typeof data === 'object' ? data : {};
        let result = new RestHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        data["started_at"] = this.started_at ? this.started_at.toISOString() : <any>undefined;
        data["duration"] = this.duration ? this.duration.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["steps"] = this.steps;
        data["distance"] = this.distance;
        data["calories"] = this.calories;
        data["run_time"] = this.run_time ? this.run_time.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        data["rest_time"] = this.rest_time ? this.rest_time.format('d.hh:mm:ss.SS', { trim: false }) : <any>undefined;
        return data;
    }
}

export interface IRestHistory {
    type?: SafeZoneType;
    name?: string | undefined;
    started_at?: moment.Moment;
    duration?: moment.Duration;
    steps?: number;
    distance?: number;
    calories?: number;
    run_time?: moment.Duration;
    rest_time?: moment.Duration;
}

/** 0 = Undefined 1 = Geo 2 = WiFi 3 = Ble */
export enum SafeZoneType {
    Undefined = 0,
    Geo = 1,
    WiFi = 2,
    Ble = 3,
}

export class Invite2 implements IInvite2 {
    id?: string;
    email?: string | undefined;
    level?: PetShareLevel | undefined;
    create_date?: moment.Moment;
    update_date?: moment.Moment;
    target_user?: CustomerPartial | undefined;

    constructor(data?: IInvite2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.level = _data["level"];
            this.create_date = _data["create_date"] ? moment(_data["create_date"].toString()) : <any>undefined;
            this.update_date = _data["update_date"] ? moment(_data["update_date"].toString()) : <any>undefined;
            this.target_user = _data["target_user"] ? CustomerPartial.fromJS(_data["target_user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Invite2 {
        data = typeof data === 'object' ? data : {};
        let result = new Invite2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["level"] = this.level;
        data["create_date"] = this.create_date ? this.create_date.toISOString() : <any>undefined;
        data["update_date"] = this.update_date ? this.update_date.toISOString() : <any>undefined;
        data["target_user"] = this.target_user ? this.target_user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInvite2 {
    id?: string;
    email?: string | undefined;
    level?: PetShareLevel | undefined;
    create_date?: moment.Moment;
    update_date?: moment.Moment;
    target_user?: CustomerPartial | undefined;
}

export class IdResult implements IIdResult {
    id?: string;

    constructor(data?: IIdResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IdResult {
        data = typeof data === 'object' ? data : {};
        let result = new IdResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IIdResult {
    id?: string;
}

export class AddAccessPoint implements IAddAccessPoint {
    ssid?: string | undefined;
    password?: string | undefined;
    connection_status?: AccessPointConnectionStatus | undefined;

    constructor(data?: IAddAccessPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ssid = _data["ssid"];
            this.password = _data["password"];
            this.connection_status = _data["connection_status"];
        }
    }

    static fromJS(data: any): AddAccessPoint {
        data = typeof data === 'object' ? data : {};
        let result = new AddAccessPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ssid"] = this.ssid;
        data["password"] = this.password;
        data["connection_status"] = this.connection_status;
        return data;
    }
}

export interface IAddAccessPoint {
    ssid?: string | undefined;
    password?: string | undefined;
    connection_status?: AccessPointConnectionStatus | undefined;
}

export class AddBeacon implements IAddBeacon {
    /** Beacon name */
    name?: string | undefined;
    /** MAC address of beacon */
    mac_address?: string | undefined;
    /** Mark the beacon as a restricted area */
    restricted?: boolean;
    /** Beacon voltage */
    voltage?: number | undefined;

    constructor(data?: IAddBeacon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.mac_address = _data["mac_address"];
            this.restricted = _data["restricted"];
            this.voltage = _data["voltage"];
        }
    }

    static fromJS(data: any): AddBeacon {
        data = typeof data === 'object' ? data : {};
        let result = new AddBeacon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["mac_address"] = this.mac_address;
        data["restricted"] = this.restricted;
        data["voltage"] = this.voltage;
        return data;
    }
}

export interface IAddBeacon {
    /** Beacon name */
    name?: string | undefined;
    /** MAC address of beacon */
    mac_address?: string | undefined;
    /** Mark the beacon as a restricted area */
    restricted?: boolean;
    /** Beacon voltage */
    voltage?: number | undefined;
}

export class BreedLegacy implements IBreedLegacy {
    id?: string;
    name?: string | undefined;

    constructor(data?: IBreedLegacy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BreedLegacy {
        data = typeof data === 'object' ? data : {};
        let result = new BreedLegacy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IBreedLegacy {
    id?: string;
    name?: string | undefined;
}

export class WidgetPet implements IWidgetPet {
    id?: string;
    alias?: string | undefined;
    mode?: DeviceMode;
    charge?: number | undefined;
    daily_goal?: number | undefined;
    flashlight?: FlashlightStatus | undefined;
    updated_at?: moment.Moment;

    constructor(data?: IWidgetPet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.alias = _data["alias"];
            this.mode = _data["mode"];
            this.charge = _data["charge"];
            this.daily_goal = _data["daily_goal"];
            this.flashlight = _data["flashlight"];
            this.updated_at = _data["updated_at"] ? moment(_data["updated_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WidgetPet {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetPet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alias"] = this.alias;
        data["mode"] = this.mode;
        data["charge"] = this.charge;
        data["daily_goal"] = this.daily_goal;
        data["flashlight"] = this.flashlight;
        data["updated_at"] = this.updated_at ? this.updated_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWidgetPet {
    id?: string;
    alias?: string | undefined;
    mode?: DeviceMode;
    charge?: number | undefined;
    daily_goal?: number | undefined;
    flashlight?: FlashlightStatus | undefined;
    updated_at?: moment.Moment;
}

export class PetStatTreeDto implements IPetStatTreeDto {
    date?: moment.Moment;
    scale?: string | undefined;
    sum_duration?: number;
    sum_distance?: number;
    sum_step?: number;
    sum_calories?: number;
    avg_distance_day?: number;
    items?: PetStatTreeDto[] | undefined;

    constructor(data?: IPetStatTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.scale = _data["scale"];
            this.sum_duration = _data["sum_duration"];
            this.sum_distance = _data["sum_distance"];
            this.sum_step = _data["sum_step"];
            this.sum_calories = _data["sum_calories"];
            this.avg_distance_day = _data["avg_distance_day"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PetStatTreeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PetStatTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PetStatTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["scale"] = this.scale;
        data["sum_duration"] = this.sum_duration;
        data["sum_distance"] = this.sum_distance;
        data["sum_step"] = this.sum_step;
        data["sum_calories"] = this.sum_calories;
        data["avg_distance_day"] = this.avg_distance_day;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPetStatTreeDto {
    date?: moment.Moment;
    scale?: string | undefined;
    sum_duration?: number;
    sum_distance?: number;
    sum_step?: number;
    sum_calories?: number;
    avg_distance_day?: number;
    items?: PetStatTreeDto[] | undefined;
}

/** 0 = Hour 1 = Day 2 = Week 3 = Month 4 = Year */
export enum Scale {
    Hour = 0,
    Day = 1,
    Week = 2,
    Month = 3,
    Year = 4,
}

export class PetRestTreeDto implements IPetRestTreeDto {
    date?: moment.Moment;
    scale?: string | undefined;
    sum_duration?: number;
    items?: PetRestTreeDto[] | undefined;

    constructor(data?: IPetRestTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.scale = _data["scale"];
            this.sum_duration = _data["sum_duration"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PetRestTreeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PetRestTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PetRestTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["scale"] = this.scale;
        data["sum_duration"] = this.sum_duration;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPetRestTreeDto {
    date?: moment.Moment;
    scale?: string | undefined;
    sum_duration?: number;
    items?: PetRestTreeDto[] | undefined;
}

export class PagedListOfFirmwareHistoryListItemDto implements IPagedListOfFirmwareHistoryListItemDto {
    items!: FirmwareHistoryListItemDto[];
    meta!: PagedListMeta;

    constructor(data?: IPagedListOfFirmwareHistoryListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.meta = new PagedListMeta();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FirmwareHistoryListItemDto.fromJS(item));
            }
            this.meta = _data["meta"] ? PagedListMeta.fromJS(_data["meta"]) : new PagedListMeta();
        }
    }

    static fromJS(data: any): PagedListOfFirmwareHistoryListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfFirmwareHistoryListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPagedListOfFirmwareHistoryListItemDto {
    items: FirmwareHistoryListItemDto[];
    meta: PagedListMeta;
}

export class FirmwareHistoryListItemDto implements IFirmwareHistoryListItemDto {
    id?: string;
    version?: string;
    comment?: string | undefined;
    status?: DeviceFirmwareStatus;
    date?: moment.Moment;

    constructor(data?: IFirmwareHistoryListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.version = _data["version"];
            this.comment = _data["comment"];
            this.status = _data["status"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FirmwareHistoryListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FirmwareHistoryListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["version"] = this.version;
        data["comment"] = this.comment;
        data["status"] = this.status;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFirmwareHistoryListItemDto {
    id?: string;
    version?: string;
    comment?: string | undefined;
    status?: DeviceFirmwareStatus;
    date?: moment.Moment;
}

/** 5 = Legacy 10 = Installed 15 = Available */
export enum DeviceFirmwareStatus {
    Legacy = 5,
    Installed = 10,
    Available = 15,
}

export class PagedListMeta implements IPagedListMeta {
    total_count?: number;
    page_count?: number;
    current_page?: number;
    per_page?: number;

    constructor(data?: IPagedListMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total_count = _data["total_count"];
            this.page_count = _data["page_count"];
            this.current_page = _data["current_page"];
            this.per_page = _data["per_page"];
        }
    }

    static fromJS(data: any): PagedListMeta {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total_count"] = this.total_count;
        data["page_count"] = this.page_count;
        data["current_page"] = this.current_page;
        data["per_page"] = this.per_page;
        return data;
    }
}

export interface IPagedListMeta {
    total_count?: number;
    page_count?: number;
    current_page?: number;
    per_page?: number;
}

export class WidgetDevice implements IWidgetDevice {
    type?: DevicesType;
    charge?: number | undefined;
    name?: string | undefined;
    id?: string;

    constructor(data?: IWidgetDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.charge = _data["charge"];
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WidgetDevice {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetDevice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["charge"] = this.charge;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IWidgetDevice {
    type?: DevicesType;
    charge?: number | undefined;
    name?: string | undefined;
    id?: string;
}

/** 0 = Collar 1 = Battery 2 = Beacon 3 = Flashlight 4 = Lora 5 = Door -1 = None */
export enum DevicesType {
    Collar = 0,
    Battery = 1,
    Beacon = 2,
    Flashlight = 3,
    Lora = 4,
    Door = 5,
    None = -1,
}

export class OnboardingResult implements IOnboardingResult {
    pet_id?: string;

    constructor(data?: IOnboardingResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pet_id = _data["pet_id"];
        }
    }

    static fromJS(data: any): OnboardingResult {
        data = typeof data === 'object' ? data : {};
        let result = new OnboardingResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pet_id"] = this.pet_id;
        return data;
    }
}

export interface IOnboardingResult {
    pet_id?: string;
}

export class Customer extends CustomerPartial implements ICustomer {
    sex?: Sex | undefined;
    note?: string | undefined;
    pets?: PetLegacy[] | undefined;

    constructor(data?: ICustomer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sex = _data["sex"];
            this.note = _data["note"];
            if (Array.isArray(_data["pets"])) {
                this.pets = [] as any;
                for (let item of _data["pets"])
                    this.pets!.push(PetLegacy.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sex"] = this.sex;
        data["note"] = this.note;
        if (Array.isArray(this.pets)) {
            data["pets"] = [];
            for (let item of this.pets)
                data["pets"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICustomer extends ICustomerPartial {
    sex?: Sex | undefined;
    note?: string | undefined;
    pets?: PetLegacy[] | undefined;
}

export class PetPartialLegacy implements IPetPartialLegacy {
    id?: string;
    alias?: string | undefined;
    avatar?: string | undefined;

    constructor(data?: IPetPartialLegacy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.alias = _data["alias"];
            this.avatar = _data["avatar"];
        }
    }

    static fromJS(data: any): PetPartialLegacy {
        data = typeof data === 'object' ? data : {};
        let result = new PetPartialLegacy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alias"] = this.alias;
        data["avatar"] = this.avatar;
        return data;
    }
}

export interface IPetPartialLegacy {
    id?: string;
    alias?: string | undefined;
    avatar?: string | undefined;
}

export class PetLegacy extends PetPartialLegacy implements IPetLegacy {
    access_level?: PetShareLevel;
    owner_id?: string;
    breed?: BreedLegacy | undefined;
    full_name?: string | undefined;
    sex?: Sex | undefined;
    birth_date?: moment.Moment;
    note?: string | undefined;
    weight?: number | undefined;
    height?: number | undefined;
    goal?: number | undefined;

    constructor(data?: IPetLegacy) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.access_level = _data["access_level"];
            this.owner_id = _data["owner_id"];
            this.breed = _data["breed"] ? BreedLegacy.fromJS(_data["breed"]) : <any>undefined;
            this.full_name = _data["full_name"];
            this.sex = _data["sex"];
            this.birth_date = _data["birth_date"] ? moment(_data["birth_date"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.weight = _data["weight"];
            this.height = _data["height"];
            this.goal = _data["goal"];
        }
    }

    static override fromJS(data: any): PetLegacy {
        data = typeof data === 'object' ? data : {};
        let result = new PetLegacy();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access_level"] = this.access_level;
        data["owner_id"] = this.owner_id;
        data["breed"] = this.breed ? this.breed.toJSON() : <any>undefined;
        data["full_name"] = this.full_name;
        data["sex"] = this.sex;
        data["birth_date"] = this.birth_date ? this.birth_date.format('YYYY-MM-DD') : <any>undefined;
        data["note"] = this.note;
        data["weight"] = this.weight;
        data["height"] = this.height;
        data["goal"] = this.goal;
        super.toJSON(data);
        return data;
    }
}

export interface IPetLegacy extends IPetPartialLegacy {
    access_level?: PetShareLevel;
    owner_id?: string;
    breed?: BreedLegacy | undefined;
    full_name?: string | undefined;
    sex?: Sex | undefined;
    birth_date?: moment.Moment;
    note?: string | undefined;
    weight?: number | undefined;
    height?: number | undefined;
    goal?: number | undefined;
}

export class CustomerPrivate extends CustomerPartial implements ICustomerPrivate {
    sex?: Sex | undefined;
    note?: string | undefined;
    phone?: string | undefined;
    email_confirmed?: boolean;
    new_email?: string | undefined;
    measurement_system?: MeasurementSystem | undefined;
    weight_measurement?: MeasurementSystem | undefined;
    distance_measurement?: MeasurementSystem | undefined;
    temperature_measurement?: TemperatureScale;
    track_view_level?: TrackViewLevel;
    pet_view_level?: PetViewLevel;
    invites?: InviteDto[] | undefined;

    constructor(data?: ICustomerPrivate) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sex = _data["sex"];
            this.note = _data["note"];
            this.phone = _data["phone"];
            this.email_confirmed = _data["email_confirmed"];
            this.new_email = _data["new_email"];
            this.measurement_system = _data["measurement_system"];
            this.weight_measurement = _data["weight_measurement"];
            this.distance_measurement = _data["distance_measurement"];
            this.temperature_measurement = _data["temperature_measurement"];
            this.track_view_level = _data["track_view_level"];
            this.pet_view_level = _data["pet_view_level"];
            if (Array.isArray(_data["invites"])) {
                this.invites = [] as any;
                for (let item of _data["invites"])
                    this.invites!.push(InviteDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CustomerPrivate {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerPrivate();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sex"] = this.sex;
        data["note"] = this.note;
        data["phone"] = this.phone;
        data["email_confirmed"] = this.email_confirmed;
        data["new_email"] = this.new_email;
        data["measurement_system"] = this.measurement_system;
        data["weight_measurement"] = this.weight_measurement;
        data["distance_measurement"] = this.distance_measurement;
        data["temperature_measurement"] = this.temperature_measurement;
        data["track_view_level"] = this.track_view_level;
        data["pet_view_level"] = this.pet_view_level;
        if (Array.isArray(this.invites)) {
            data["invites"] = [];
            for (let item of this.invites)
                data["invites"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICustomerPrivate extends ICustomerPartial {
    sex?: Sex | undefined;
    note?: string | undefined;
    phone?: string | undefined;
    email_confirmed?: boolean;
    new_email?: string | undefined;
    measurement_system?: MeasurementSystem | undefined;
    weight_measurement?: MeasurementSystem | undefined;
    distance_measurement?: MeasurementSystem | undefined;
    temperature_measurement?: TemperatureScale;
    track_view_level?: TrackViewLevel;
    pet_view_level?: PetViewLevel;
    invites?: InviteDto[] | undefined;
}

export class InviteDto implements IInviteDto {
    id?: string;
    email?: string | undefined;
    level?: PetShareLevel | undefined;
    create_date?: moment.Moment;
    update_date?: moment.Moment;
    pet?: PetLegacy | undefined;
    user?: CustomerPartial | undefined;

    constructor(data?: IInviteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.level = _data["level"];
            this.create_date = _data["create_date"] ? moment(_data["create_date"].toString()) : <any>undefined;
            this.update_date = _data["update_date"] ? moment(_data["update_date"].toString()) : <any>undefined;
            this.pet = _data["pet"] ? PetLegacy.fromJS(_data["pet"]) : <any>undefined;
            this.user = _data["user"] ? CustomerPartial.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InviteDto {
        data = typeof data === 'object' ? data : {};
        let result = new InviteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["level"] = this.level;
        data["create_date"] = this.create_date ? this.create_date.toISOString() : <any>undefined;
        data["update_date"] = this.update_date ? this.update_date.toISOString() : <any>undefined;
        data["pet"] = this.pet ? this.pet.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInviteDto {
    id?: string;
    email?: string | undefined;
    level?: PetShareLevel | undefined;
    create_date?: moment.Moment;
    update_date?: moment.Moment;
    pet?: PetLegacy | undefined;
    user?: CustomerPartial | undefined;
}

export class FlowListOfFeed implements IFlowListOfFeed {
    items!: Feed[];
    meta!: FlowListMeta;

    constructor(data?: IFlowListOfFeed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.meta = new FlowListMeta();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Feed.fromJS(item));
            }
            this.meta = _data["meta"] ? FlowListMeta.fromJS(_data["meta"]) : new FlowListMeta();
        }
    }

    static fromJS(data: any): FlowListOfFeed {
        data = typeof data === 'object' ? data : {};
        let result = new FlowListOfFeed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFlowListOfFeed {
    items: Feed[];
    meta: FlowListMeta;
}

export class Feed implements IFeed {
    timestamp?: moment.Moment;
    message?: string | undefined;
    type?: string | undefined;
    icons?: string[] | undefined;
    badge?: string | undefined;
    badge_url?: string | undefined;
    badge_color?: string | undefined;
    data?: { [key: string]: any; } | undefined;
    pet?: PetPartialLegacy | undefined;
    user?: CustomerPartial | undefined;
    achievement?: AchievementTypePartial | undefined;

    constructor(data?: IFeed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>undefined;
            this.message = _data["message"];
            this.type = _data["type"];
            if (Array.isArray(_data["icons"])) {
                this.icons = [] as any;
                for (let item of _data["icons"])
                    this.icons!.push(item);
            }
            this.badge = _data["badge"];
            this.badge_url = _data["badge_url"];
            this.badge_color = _data["badge_color"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
            this.pet = _data["pet"] ? PetPartialLegacy.fromJS(_data["pet"]) : <any>undefined;
            this.user = _data["user"] ? CustomerPartial.fromJS(_data["user"]) : <any>undefined;
            this.achievement = _data["achievement"] ? AchievementTypePartial.fromJS(_data["achievement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Feed {
        data = typeof data === 'object' ? data : {};
        let result = new Feed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["message"] = this.message;
        data["type"] = this.type;
        if (Array.isArray(this.icons)) {
            data["icons"] = [];
            for (let item of this.icons)
                data["icons"].push(item);
        }
        data["badge"] = this.badge;
        data["badge_url"] = this.badge_url;
        data["badge_color"] = this.badge_color;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        data["pet"] = this.pet ? this.pet.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["achievement"] = this.achievement ? this.achievement.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFeed {
    timestamp?: moment.Moment;
    message?: string | undefined;
    type?: string | undefined;
    icons?: string[] | undefined;
    badge?: string | undefined;
    badge_url?: string | undefined;
    badge_color?: string | undefined;
    data?: { [key: string]: any; } | undefined;
    pet?: PetPartialLegacy | undefined;
    user?: CustomerPartial | undefined;
    achievement?: AchievementTypePartial | undefined;
}

export class AchievementTypePartial implements IAchievementTypePartial {
    id?: string | undefined;
    icon?: string | undefined;

    constructor(data?: IAchievementTypePartial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.icon = _data["icon"];
        }
    }

    static fromJS(data: any): AchievementTypePartial {
        data = typeof data === 'object' ? data : {};
        let result = new AchievementTypePartial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["icon"] = this.icon;
        return data;
    }
}

export interface IAchievementTypePartial {
    id?: string | undefined;
    icon?: string | undefined;
}

export class FlowListMeta implements IFlowListMeta {
    from?: moment.Moment;
    to?: moment.Moment;

    constructor(data?: IFlowListMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FlowListMeta {
        data = typeof data === 'object' ? data : {};
        let result = new FlowListMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFlowListMeta {
    from?: moment.Moment;
    to?: moment.Moment;
}

/** 0 = None 1 = Email 2 = Push 3 = All */
export enum DeliveryTypeFlags {
    None = 0,
    Email = 1,
    Push = 2,
    All = 3,
}

export class SubscriptionPrice implements ISubscriptionPrice {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    label?: string | undefined;
    /** The frequency at which a subscription is billed. One of day, week,
month or year.
One of: day, month, week, or year. */
    interval?: string | undefined;
    /** The number of intervals (specified in the interval attribute) between
subscription billings. For example, interval=month and interval_count=3
bills every 3 months. */
    interval_count?: number;
    /** Default number of trial days when subscribing a customer to this plan. */
    trial_period?: number;
    /** The unit amount in %s to be charged, represented as a decimal with at most 12 decimal places. */
    price?: number;
    price_per_month?: number;
    default?: boolean | undefined;

    constructor(data?: ISubscriptionPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.label = _data["label"];
            this.interval = _data["interval"];
            this.interval_count = _data["interval_count"];
            this.trial_period = _data["trial_period"];
            this.price = _data["price"];
            this.price_per_month = _data["price_per_month"];
            this.default = _data["default"];
        }
    }

    static fromJS(data: any): SubscriptionPrice {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["label"] = this.label;
        data["interval"] = this.interval;
        data["interval_count"] = this.interval_count;
        data["trial_period"] = this.trial_period;
        data["price"] = this.price;
        data["price_per_month"] = this.price_per_month;
        data["default"] = this.default;
        return data;
    }
}

export interface ISubscriptionPrice {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    label?: string | undefined;
    /** The frequency at which a subscription is billed. One of day, week,
month or year.
One of: day, month, week, or year. */
    interval?: string | undefined;
    /** The number of intervals (specified in the interval attribute) between
subscription billings. For example, interval=month and interval_count=3
bills every 3 months. */
    interval_count?: number;
    /** Default number of trial days when subscribing a customer to this plan. */
    trial_period?: number;
    /** The unit amount in %s to be charged, represented as a decimal with at most 12 decimal places. */
    price?: number;
    price_per_month?: number;
    default?: boolean | undefined;
}

export class Subscription implements ISubscription {
    /** Define the pet description of assigned subscription. */
    pet?: AssignedPet | undefined;
    /** Date when the subscription was first created. */
    start_date?: moment.Moment;
    /** A date in the future at which the subscription will automatically get canceled. */
    cancel_at?: moment.Moment | undefined;
    /** If the subscription has a trial, the end of that trial. */
    trial_end?: moment.Moment | undefined;
    /** Start of the current period that the subscription has been invoiced for. */
    current_period_start?: moment.Moment;
    /** End of the current period that the subscription has been invoiced for. At the end of this period, a new invoice will be created. */
    current_period_end?: moment.Moment;
    /** If the subscription has ended, the date the subscription ended. */
    ended_at?: moment.Moment | undefined;
    /** active, canceled, past_due, trialing */
    status?: string | undefined;
    /** Define the base price and billing cycle for recurring purchases of products. */
    price?: SubscriptionPrice | undefined;
    /** Default payment method for the subscription. */
    default_payment_method?: PaymentMethod | undefined;
    /** The most recent invoice this subscription has generated. */
    latest_invoice?: Invoice | undefined;
    device?: SubscriptionTarget | undefined;

    constructor(data?: ISubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pet = _data["pet"] ? AssignedPet.fromJS(_data["pet"]) : <any>undefined;
            this.start_date = _data["start_date"] ? moment(_data["start_date"].toString()) : <any>undefined;
            this.cancel_at = _data["cancel_at"] ? moment(_data["cancel_at"].toString()) : <any>undefined;
            this.trial_end = _data["trial_end"] ? moment(_data["trial_end"].toString()) : <any>undefined;
            this.current_period_start = _data["current_period_start"] ? moment(_data["current_period_start"].toString()) : <any>undefined;
            this.current_period_end = _data["current_period_end"] ? moment(_data["current_period_end"].toString()) : <any>undefined;
            this.ended_at = _data["ended_at"] ? moment(_data["ended_at"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.price = _data["price"] ? SubscriptionPrice.fromJS(_data["price"]) : <any>undefined;
            this.default_payment_method = _data["default_payment_method"] ? PaymentMethod.fromJS(_data["default_payment_method"]) : <any>undefined;
            this.latest_invoice = _data["latest_invoice"] ? Invoice.fromJS(_data["latest_invoice"]) : <any>undefined;
            this.device = _data["device"] ? SubscriptionTarget.fromJS(_data["device"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Subscription {
        data = typeof data === 'object' ? data : {};
        let result = new Subscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pet"] = this.pet ? this.pet.toJSON() : <any>undefined;
        data["start_date"] = this.start_date ? this.start_date.toISOString() : <any>undefined;
        data["cancel_at"] = this.cancel_at ? this.cancel_at.toISOString() : <any>undefined;
        data["trial_end"] = this.trial_end ? this.trial_end.toISOString() : <any>undefined;
        data["current_period_start"] = this.current_period_start ? this.current_period_start.toISOString() : <any>undefined;
        data["current_period_end"] = this.current_period_end ? this.current_period_end.toISOString() : <any>undefined;
        data["ended_at"] = this.ended_at ? this.ended_at.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["price"] = this.price ? this.price.toJSON() : <any>undefined;
        data["default_payment_method"] = this.default_payment_method ? this.default_payment_method.toJSON() : <any>undefined;
        data["latest_invoice"] = this.latest_invoice ? this.latest_invoice.toJSON() : <any>undefined;
        data["device"] = this.device ? this.device.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubscription {
    /** Define the pet description of assigned subscription. */
    pet?: AssignedPet | undefined;
    /** Date when the subscription was first created. */
    start_date?: moment.Moment;
    /** A date in the future at which the subscription will automatically get canceled. */
    cancel_at?: moment.Moment | undefined;
    /** If the subscription has a trial, the end of that trial. */
    trial_end?: moment.Moment | undefined;
    /** Start of the current period that the subscription has been invoiced for. */
    current_period_start?: moment.Moment;
    /** End of the current period that the subscription has been invoiced for. At the end of this period, a new invoice will be created. */
    current_period_end?: moment.Moment;
    /** If the subscription has ended, the date the subscription ended. */
    ended_at?: moment.Moment | undefined;
    /** active, canceled, past_due, trialing */
    status?: string | undefined;
    /** Define the base price and billing cycle for recurring purchases of products. */
    price?: SubscriptionPrice | undefined;
    /** Default payment method for the subscription. */
    default_payment_method?: PaymentMethod | undefined;
    /** The most recent invoice this subscription has generated. */
    latest_invoice?: Invoice | undefined;
    device?: SubscriptionTarget | undefined;
}

export class AssignedPet implements IAssignedPet {
    id?: string;
    breed?: string | undefined;
    alias?: string | undefined;
    avatar?: string | undefined;
    owner?: Owner | undefined;

    constructor(data?: IAssignedPet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.breed = _data["breed"];
            this.alias = _data["alias"];
            this.avatar = _data["avatar"];
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AssignedPet {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedPet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["breed"] = this.breed;
        data["alias"] = this.alias;
        data["avatar"] = this.avatar;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAssignedPet {
    id?: string;
    breed?: string | undefined;
    alias?: string | undefined;
    avatar?: string | undefined;
    owner?: Owner | undefined;
}

export class Owner implements IOwner {
    id?: string;
    first_name?: string | undefined;
    last_name?: string | undefined;
    avatar?: string | undefined;

    constructor(data?: IOwner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.first_name = _data["first_name"];
            this.last_name = _data["last_name"];
            this.avatar = _data["avatar"];
        }
    }

    static fromJS(data: any): Owner {
        data = typeof data === 'object' ? data : {};
        let result = new Owner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["first_name"] = this.first_name;
        data["last_name"] = this.last_name;
        data["avatar"] = this.avatar;
        return data;
    }
}

export interface IOwner {
    id?: string;
    first_name?: string | undefined;
    last_name?: string | undefined;
    avatar?: string | undefined;
}

export class PaymentMethod implements IPaymentMethod {
    /** Unique identifier for the object. */
    id?: string | undefined;
    /** The type of the PaymentMethod. An additional hash is included on the PaymentMethod with
a name matching this value. It contains additional information specific to the
PaymentMethod type.
Right now only card is supported. */
    type?: string | undefined;
    card?: PaymentMethodCard | undefined;
    default?: boolean;

    constructor(data?: IPaymentMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.card = _data["card"] ? PaymentMethodCard.fromJS(_data["card"]) : <any>undefined;
            this.default = _data["default"];
        }
    }

    static fromJS(data: any): PaymentMethod {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["card"] = this.card ? this.card.toJSON() : <any>undefined;
        data["default"] = this.default;
        return data;
    }
}

export interface IPaymentMethod {
    /** Unique identifier for the object. */
    id?: string | undefined;
    /** The type of the PaymentMethod. An additional hash is included on the PaymentMethod with
a name matching this value. It contains additional information specific to the
PaymentMethod type.
Right now only card is supported. */
    type?: string | undefined;
    card?: PaymentMethodCard | undefined;
    default?: boolean;
}

export class PaymentMethodCard implements IPaymentMethodCard {
    /** Card brand. Can be amex, diners, discover, jcb,
mastercard, unionpay, visa, or unknown. */
    brand?: string | undefined;
    /** Two-digit number representing the card's expiration month. */
    exp_month?: number;
    /** Four-digit number representing the card's expiration year. */
    exp_year?: number;
    /** The last four digits of the card. */
    last4?: string | undefined;

    constructor(data?: IPaymentMethodCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.brand = _data["brand"];
            this.exp_month = _data["exp_month"];
            this.exp_year = _data["exp_year"];
            this.last4 = _data["last4"];
        }
    }

    static fromJS(data: any): PaymentMethodCard {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["brand"] = this.brand;
        data["exp_month"] = this.exp_month;
        data["exp_year"] = this.exp_year;
        data["last4"] = this.last4;
        return data;
    }
}

export interface IPaymentMethodCard {
    /** Card brand. Can be amex, diners, discover, jcb,
mastercard, unionpay, visa, or unknown. */
    brand?: string | undefined;
    /** Two-digit number representing the card's expiration month. */
    exp_month?: number;
    /** Four-digit number representing the card's expiration year. */
    exp_year?: number;
    /** The last four digits of the card. */
    last4?: string | undefined;
}

export class Invoice implements IInvoice {
    /** A unique, identifying string that appears on emails sent to the customer for this
invoice. This starts with the customer's unique invoice_prefix if it is specified. */
    number?: string | undefined;
    /** The link to download the PDF for the invoice. If the invoice has not been finalized yet,
this will be null. */
    invoice_pdf?: string | undefined;
    /** The PaymentIntent associated with this invoice. The PaymentIntent is generated when the
invoice is finalized, and can then be used to pay the invoice. Note that voiding an
invoice will cancel the PaymentIntent. */
    payment_intent?: PaymentIntent | undefined;

    constructor(data?: IInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.invoice_pdf = _data["invoice_pdf"];
            this.payment_intent = _data["payment_intent"] ? PaymentIntent.fromJS(_data["payment_intent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Invoice {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["invoice_pdf"] = this.invoice_pdf;
        data["payment_intent"] = this.payment_intent ? this.payment_intent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInvoice {
    /** A unique, identifying string that appears on emails sent to the customer for this
invoice. This starts with the customer's unique invoice_prefix if it is specified. */
    number?: string | undefined;
    /** The link to download the PDF for the invoice. If the invoice has not been finalized yet,
this will be null. */
    invoice_pdf?: string | undefined;
    /** The PaymentIntent associated with this invoice. The PaymentIntent is generated when the
invoice is finalized, and can then be used to pay the invoice. Note that voiding an
invoice will cancel the PaymentIntent. */
    payment_intent?: PaymentIntent | undefined;
}

export class PaymentIntent implements IPaymentIntent {
    /** The client secret of this PaymentIntent. Used for client-side retrieval using a
publishable key.

The client secret can be used to complete a payment from frontend. It should not be
stored, logged, embedded in URLs, or exposed to anyone other than the customer.

Refer to our docs to accept a
payment and learn about how client_secret should be handled. */
    client_secret?: string | undefined;
    /** Status of this PaymentIntent, one of requires_payment_method,
requires_confirmation, requires_action, processing,
requires_capture, canceled, or succeeded. Read more about each
PaymentIntent status.
One of: canceled, processing, requires_action,
requires_capture, requires_confirmation, requires_payment_method,
or succeeded. */
    status?: string | undefined;
    /** The payment error encountered in the previous PaymentIntent confirmation. It will be
cleared if the PaymentIntent is later updated for any reason. */
    last_payment_error?: PaymentError | undefined;

    constructor(data?: IPaymentIntent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.client_secret = _data["client_secret"];
            this.status = _data["status"];
            this.last_payment_error = _data["last_payment_error"] ? PaymentError.fromJS(_data["last_payment_error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentIntent {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentIntent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["client_secret"] = this.client_secret;
        data["status"] = this.status;
        data["last_payment_error"] = this.last_payment_error ? this.last_payment_error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPaymentIntent {
    /** The client secret of this PaymentIntent. Used for client-side retrieval using a
publishable key.

The client secret can be used to complete a payment from frontend. It should not be
stored, logged, embedded in URLs, or exposed to anyone other than the customer.

Refer to our docs to accept a
payment and learn about how client_secret should be handled. */
    client_secret?: string | undefined;
    /** Status of this PaymentIntent, one of requires_payment_method,
requires_confirmation, requires_action, processing,
requires_capture, canceled, or succeeded. Read more about each
PaymentIntent status.
One of: canceled, processing, requires_action,
requires_capture, requires_confirmation, requires_payment_method,
or succeeded. */
    status?: string | undefined;
    /** The payment error encountered in the previous PaymentIntent confirmation. It will be
cleared if the PaymentIntent is later updated for any reason. */
    last_payment_error?: PaymentError | undefined;
}

export class PaymentError implements IPaymentError {
    /** For some errors that could be handled programmatically, a short string indicating the
error code reported. */
    code?: string | undefined;
    /** For card errors resulting from a card issuer decline, a short string indicating the
card issuer's reason for the
decline. */
    decline_code?: string | undefined;
    /** A human-readable message providing more details about the error. For card errors, these
messages can be shown to your users. */
    message?: string | undefined;

    constructor(data?: IPaymentError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.decline_code = _data["decline_code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PaymentError {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["decline_code"] = this.decline_code;
        data["message"] = this.message;
        return data;
    }
}

export interface IPaymentError {
    /** For some errors that could be handled programmatically, a short string indicating the
error code reported. */
    code?: string | undefined;
    /** For card errors resulting from a card issuer decline, a short string indicating the
card issuer's reason for the
decline. */
    decline_code?: string | undefined;
    /** A human-readable message providing more details about the error. For card errors, these
messages can be shown to your users. */
    message?: string | undefined;
}

export class SubscriptionTarget implements ISubscriptionTarget {
    id?: string;
    serial?: string | undefined;

    constructor(data?: ISubscriptionTarget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serial = _data["serial"];
        }
    }

    static fromJS(data: any): SubscriptionTarget {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionTarget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serial"] = this.serial;
        return data;
    }
}

export interface ISubscriptionTarget {
    id?: string;
    serial?: string | undefined;
}

export class Token implements IToken {
    /** The access token string. */
    access_token?: string | undefined;
    /** Duration of time in seconds the access token is granted for. */
    expires_in?: number;
    /** Zendesk access token string. */
    zendesk_token?: string | undefined;

    constructor(data?: IToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.access_token = _data["access_token"];
            this.expires_in = _data["expires_in"];
            this.zendesk_token = _data["zendesk_token"];
        }
    }

    static fromJS(data: any): Token {
        data = typeof data === 'object' ? data : {};
        let result = new Token();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access_token"] = this.access_token;
        data["expires_in"] = this.expires_in;
        data["zendesk_token"] = this.zendesk_token;
        return data;
    }
}

export interface IToken {
    /** The access token string. */
    access_token?: string | undefined;
    /** Duration of time in seconds the access token is granted for. */
    expires_in?: number;
    /** Zendesk access token string. */
    zendesk_token?: string | undefined;
}

export class Achievement2 implements IAchievement2 {
    achievement_type?: string | undefined;
    amount?: number;
    earned_first?: moment.Moment | undefined;
    earned_last?: moment.Moment | undefined;

    constructor(data?: IAchievement2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.achievement_type = _data["achievement_type"];
            this.amount = _data["amount"];
            this.earned_first = _data["earned_first"] ? moment(_data["earned_first"].toString()) : <any>undefined;
            this.earned_last = _data["earned_last"] ? moment(_data["earned_last"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Achievement2 {
        data = typeof data === 'object' ? data : {};
        let result = new Achievement2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["achievement_type"] = this.achievement_type;
        data["amount"] = this.amount;
        data["earned_first"] = this.earned_first ? this.earned_first.toISOString() : <any>undefined;
        data["earned_last"] = this.earned_last ? this.earned_last.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAchievement2 {
    achievement_type?: string | undefined;
    amount?: number;
    earned_first?: moment.Moment | undefined;
    earned_last?: moment.Moment | undefined;
}

export class PagedListOfAchievementTypeLegacy implements IPagedListOfAchievementTypeLegacy {
    items!: AchievementTypeLegacy[];
    meta!: PagedListMeta;

    constructor(data?: IPagedListOfAchievementTypeLegacy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
            this.meta = new PagedListMeta();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AchievementTypeLegacy.fromJS(item));
            }
            this.meta = _data["meta"] ? PagedListMeta.fromJS(_data["meta"]) : new PagedListMeta();
        }
    }

    static fromJS(data: any): PagedListOfAchievementTypeLegacy {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfAchievementTypeLegacy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPagedListOfAchievementTypeLegacy {
    items: AchievementTypeLegacy[];
    meta: PagedListMeta;
}

export class AchievementTypeLegacy implements IAchievementTypeLegacy {
    id?: string | undefined;
    description?: AchievementDescriptionLegacy | undefined;

    constructor(data?: IAchievementTypeLegacy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"] ? AchievementDescriptionLegacy.fromJS(_data["description"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AchievementTypeLegacy {
        data = typeof data === 'object' ? data : {};
        let result = new AchievementTypeLegacy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAchievementTypeLegacy {
    id?: string | undefined;
    description?: AchievementDescriptionLegacy | undefined;
}

export class AchievementDescriptionLegacy implements IAchievementDescriptionLegacy {
    header?: string | undefined;
    description?: string | undefined;
    group_id?: string | undefined;
    picture_url?: string | undefined;
    inactive_picture_url?: string | undefined;
    last_modified?: moment.Moment | undefined;

    constructor(data?: IAchievementDescriptionLegacy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.header = _data["header"];
            this.description = _data["description"];
            this.group_id = _data["group_id"];
            this.picture_url = _data["picture_url"];
            this.inactive_picture_url = _data["inactive_picture_url"];
            this.last_modified = _data["last_modified"] ? moment(_data["last_modified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AchievementDescriptionLegacy {
        data = typeof data === 'object' ? data : {};
        let result = new AchievementDescriptionLegacy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header;
        data["description"] = this.description;
        data["group_id"] = this.group_id;
        data["picture_url"] = this.picture_url;
        data["inactive_picture_url"] = this.inactive_picture_url;
        data["last_modified"] = this.last_modified ? this.last_modified.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAchievementDescriptionLegacy {
    header?: string | undefined;
    description?: string | undefined;
    group_id?: string | undefined;
    picture_url?: string | undefined;
    inactive_picture_url?: string | undefined;
    last_modified?: moment.Moment | undefined;
}

export class AchievementType extends AchievementTypePartial implements IAchievementType {
    header?: string | undefined;
    description?: string | undefined;
    inactive_icon?: string | undefined;

    constructor(data?: IAchievementType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.header = _data["header"];
            this.description = _data["description"];
            this.inactive_icon = _data["inactive_icon"];
        }
    }

    static override fromJS(data: any): AchievementType {
        data = typeof data === 'object' ? data : {};
        let result = new AchievementType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["header"] = this.header;
        data["description"] = this.description;
        data["inactive_icon"] = this.inactive_icon;
        super.toJSON(data);
        return data;
    }
}

export interface IAchievementType extends IAchievementTypePartial {
    header?: string | undefined;
    description?: string | undefined;
    inactive_icon?: string | undefined;
}

export class ProcessKoreWebhook implements IProcessKoreWebhook {
    alertId?: number;
    alertMessageDate?: moment.Moment;
    ruleId?: number;
    ruleName?: string | undefined;
    eventName?: string | undefined;
    account?: string | undefined;
    events?: Event[] | undefined;

    constructor(data?: IProcessKoreWebhook) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertId = _data["alert-id"];
            this.alertMessageDate = _data["alert-message-date"] ? moment(_data["alert-message-date"].toString()) : <any>undefined;
            this.ruleId = _data["rule-id"];
            this.ruleName = _data["rule-name"];
            this.eventName = _data["event-name"];
            this.account = _data["account"];
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(Event.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessKoreWebhook {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessKoreWebhook();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alert-id"] = this.alertId;
        data["alert-message-date"] = this.alertMessageDate ? this.alertMessageDate.toISOString() : <any>undefined;
        data["rule-id"] = this.ruleId;
        data["rule-name"] = this.ruleName;
        data["event-name"] = this.eventName;
        data["account"] = this.account;
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProcessKoreWebhook {
    alertId?: number;
    alertMessageDate?: moment.Moment;
    ruleId?: number;
    ruleName?: string | undefined;
    eventName?: string | undefined;
    account?: string | undefined;
    events?: Event[] | undefined;
}

export class Event implements IEvent {
    id?: string | undefined;
    data?: { [key: string]: string; } | undefined;

    constructor(data?: IEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
        }
    }

    static fromJS(data: any): Event {
        data = typeof data === 'object' ? data : {};
        let result = new Event();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        return data;
    }
}

export interface IEvent {
    id?: string | undefined;
    data?: { [key: string]: string; } | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
